const Constants = Object.freeze({
  // -----------------------------------------------------------------------------
  // -------------------------------- PROTOCOLO ----------------------------------
  // -----------------------------------------------------------------------------

  // ---------------------------- HOME ----------------------------
  TIME_ON: "Tiempo encendido: ",
  NUM_OF_DEVICES: "Número de dispositivos",
  MASTERS: "Maestros",
  SLAVES: "Esclavos",
  STATISTICS: "Estadísticas",

  NO_RETRIES: "Sin reintentos",

  BAUD_RATE_KBPS: "BAUD RATE (Kbps)",
  BAUD_RATE_MBPS: "BAUD RATE (Mbps)",

  CYCLE_TIME_S: "TIEMPO DE CICLO (s)",
  CYCLE_TIME_MS: "TIEMPO DE CICLO (ms)",

  WATCHDOG_MS: "WATCHDOG (ms)",

  RETRIES_LIMIT: "LÍMITE DE REINTENTOS",

  PROFIBUS_NETWORK_INFO: "Información de la red PROFIBUS",

  HSA_POPUP_1: "HSA (Highest PROFIBUS Address) es el parámetro que indica la dirección más alta que el maestro utiliza para buscar nuevos equipos en la red, usando el protocolo FDL_Status.",
  HSA_POPUP_2: "También se utiliza para la detección de maestros clase 2 o redes con más de un maestro.",

  // ---------------------------- Live List ----------------------------
  AVAILABILITY: "Disponibilidad",
  TAG: "Tag",
  ACTIVE: "Activo",
  INACTIVE: "Inactivo",
  REASON: "\nMotivo: ",

  EXPORT_CSV: "Exportar XLSX",
  CSV_HEADER: "Dirección,Tag,Modelo,Diagnósticos,Reintentos sin fallas,Reintentos totales,Fallas,Disponibilidad,Watchdog,Estado\n",

  PAGE: "Página",

  YEAR: " año",
  MONTH: " mes",
  MONTHS: " meses",
  DAY: " día",
  HOUR: " hora",
  MINUTE: " minuto",
  SECOND_T: " segundo",

  // ---------------------------- Log ----------------------------
  MANUFACTURER_MODEL: "Fabricante / Modelo",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN_CREDENTIALS_FAILURE: "Ocurrió un error al iniciar sesión: Nombre de usuario o contraseña incorrectos.",
  LOGIN_GENERAL_FALIURE: "Ocurrió un error al iniciar sesión:",

  GPG_ALERT_MESSAGE: "Solo es posible enviar archivos con extensión .gpg",
  SEND_FILE_FAILURE: "Ocurrió un error al enviar el archivo.",
  SEND_FILES_SUCCESS: "Los archivos fueron enviados con éxito.",
  SEND_FILE_WAITING: "Enviando el archivo.",
  SEND_FILE_WRONG_FILENAME: "Nombre inválido. El archivo de actualización debe llamarse: updatePRO.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "El archivo de actualización se corrompió durante el envío.",

  SEND_CONFIG_FAILURE: "Ocurrió un error al enviar las configuraciones.",
  SEND_CONFIG_WAITING: "Enviando las configuraciones.",
  SEND_CONFIG_WAITING_2: "Finalizando el envío de las configuraciones.",
  SEND_CONFIG_DONE: "Configuraciones enviadas.",
  SEND_NTP_CONFIG_WAITING: "Enviando las configuraciones del servidor NTP.",
  SEND_NTP_CONFIG_DONE: "Configuraciones del servidor NTP enviadas.",

  WAITING: "Espere un instante",
  CLEAN_LOG_SUCCESS: "El registro fue limpiado con éxito.",
  CLEAN_LOG_FAILURE: "Ocurrió un error al limpiar el registro.",
  CLEAN_STATISTICS_SUCCESS: "Las estadísticas fueron limpiadas con éxito.",
  CLEAN_STATISTICS_FAILURE: "Ocurrió un error al limpiar las estadísticas.",

  CHANGE_USERNAME_SUCCESS: "El nombre de usuario fue cambiado con éxito. Por favor, inicie sesión nuevamente.",
  CHANGE_USERNAME_FAILURE: "Ocurrió un error al cambiar el nombre de usuario: ",
  USERNAME_TOO_SHORT: "El nombre de usuario debe contener al menos un carácter.",
  PASSWORD_MISSMATCH: "Las contraseñas ingresadas no coinciden",
  CHANGE_PASSWORD_SUCCESS: "La contraseña fue cambiada con éxito. Por favor, inicie sesión nuevamente.",
  CHANGE_PASSWORD_FAILURE: "Ocurrió un error al cambiar la contraseña: ",

  VERIFY_THE_FOLLOWING_INFO: "Por favor verifique la siguiente información:",
  INVALID_IP: "\n- La IP ingresada es inválida",
  INVALID_SUBMASK: "\n- La máscara ingresada es inválida",
  INVALID_GATEWAY: "\n- El gateway ingresado es inválido",
  INVALID_DNS: "\n- El DNS ingresado es inválido",
  LOOPBACK_IP: "\n- La IP de loopback (127.0.0.1) no puede usarse como IP del monitor",
  LOOPBACK_IP_NTP: "\n- La IP de loopback (127.0.0.1) no puede usarse como IP del servidor NTP",
  SELECT_TIMEZONE: "\n- Es necesario seleccionar una zona horaria para configurar el servidor NTP",
  SAME_SUBNET_IP_1: "\n- La dirección IP de la interfaz WLAN no puede estar en la misma subred que la interfaz ETHERNET.",
  SAME_SUBNET_IP_2: "\n- La dirección IP de la interfaz ETHERNET no puede estar en la misma subred que la interfaz WLAN.",
  SUBNET_OVERLAP_WLAN: "\n- El TS Monitor PROFIBUS PRO detectó que existe superposición de direcciones entre la subred de la interfaz ETHERNET y la subred WLAN. Por este motivo, no es posible configurar la WLAN con la dirección IP y la máscara elegidas.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- El TS Monitor PROFIBUS PRO detectó que existe superposición de direcciones entre la subred de la interfaz ETHERNET y la subred WLAN. Por este motivo, no es posible configurar la interfaz ETHERNET con la dirección IP y la máscara elegidas.",
  ZERO_IP_MSG: "\n- La IP 0.0.0.0 no puede utilizarse como IP del TS Monitor PROFIBUS PRO",
  ZERO_IP_MASK_MSG: "\n- La IP 0.0.0.0 no puede utilizarse como máscara de red",
  BROADCAST_IP_MSG: "\n- La IP de broadcast de la red no puede utilizarse como IP del TS Monitor PROFIBUS PRO",
  NETWORK_IP_MSG: "\n- La IP de la red no puede utilizarse como IP del TS Monitor PROFIBUS PRO",
  BROADCAST_GATEWAY_MSG: "\n- La IP de broadcast de la red no puede utilizarse como IP del gateway",
  NETWORK_GATEWAY_MSG: "\n- La IP de la red no puede utilizarse como IP del gateway",

  EMPTY_WIFI_PWD: "\n- La contraseña de Wi-Fi no puede estar vacía",

  ALTER_USERNAME: "CAMBIAR USUARIO",
  ALTER_PASSWORD: "CAMBIAR CONTRASEÑA",

  RESTART_SYSTEM: " Reiniciar sistema",
  CONFIRM_RESTART_SYSTEM: "¿Está seguro de que desea reiniciar el sistema?",
  RESTART_SYSTEM_FAILURE: "Ocurrió un error al intentar reiniciar el sistema.",
  RESTART_SYSTEM_SUCCESS: "Solicitud de reinicio enviada con éxito. Espere aproximadamente 3 minutos para que el sistema se reinicie completamente.",

  SELECT_FILE: "Por favor seleccione un archivo para enviar",
  SELECT_GSD_FLIE: "Por favor seleccione al menos un archivo GSD para enviar",
  SENDING_GSD_FILES: "Enviando archivos GSD",

  DO_NOT_CLOSE_THIS_TAB: "Deje esta pestaña abierta para seguir la actualización.",
  UPDATING_MONITOR_FILES: "Actualizando archivos en el monitor. Por favor espere.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Archivos actualizados, preparándose para reiniciar el monitor.",
  RESTARTING_MONITOR_WAIT: "Reiniciando el monitor, espere algunos minutos.",
  UPDATE_SUCCESS: "¡La actualización se realizó con éxito!",
  UPDATE_ERROR_STRING: "Ocurrió el siguiente error al actualizar el monitor: ",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modifique al menos uno de los campos para actualizar las configuraciones de la interfaz.",
  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modifique al menos uno de los campos para actualizar las configuraciones WLAN.",

  TAG_WAS_CHANGED_SUCCESSFULLY: "La tag del monitor fue modificada con éxito.",
  TAG_CHANGE_FAILURE: "Ocurrió un error al modificar la tag del monitor.",

  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nRecuerde actualizar la dirección en el navegador a: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "¡Las configuraciones de la interfaz fueron actualizadas con éxito!",
  UPDATE_WLAN_CONFIG_SUCCESS: "¡Las configuraciones de WLAN fueron actualizadas con éxito!",

  THE_FOLLOWING_FILES_COULD_NOT_BE_SENT: "Ocurrió un error al enviar los siguientes archivos GSD: ",
  THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED: "Ocurrió un error al eliminar los siguientes archivos GSD: ",

  MANAGE: "Gestionar",

  TAG_CONFIG: "Tag de la red",

  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Campo de configuración de la interfaz Ethernet.",
  ETHERNET_POPUP_2: "Utilizado para supervisión y acceso Web a los datos del monitor.",

  WLAN: "WLAN",
  WLAN_POPUP_1: "Campo de configuración de la interfaz inalámbrica, cuando el adaptador esté disponible.",
  WLAN_POPUP_2: "Utilizado para supervisión y acceso Web a los datos del monitor.",

  NTP_SERVER: "Servidor NTP",

  TURN_NTP_SERVER_ON: "Encender servidor NTP",
  TURN_NTP_SERVER_ON_QUESTION: "¿Está seguro de que desea encender el servidor NTP? Para ello, será necesario reiniciar el monitor.",

  NTP_INFO_TURNED_ON_FAILURE: "Ocurrió un error al encender el servidor NTP.",

  PROCESSING_NTP_INIT: "Iniciando el procesamiento de la información del servidor NTP",
  PROCESSING_NTP_INFO: "Procesando la información del servidor NTP.",
  PROCESSED_NTP_INFO: "Información del servidor NTP procesada.",
  PROCESSING_NTP_ERROR: "Ocurrió un error al enviar la información al servidor NTP. Verifique si la dirección IP del servidor es correcta. Si lo es, verifique también si el servicio NTP está encendido e intente nuevamente.",

  MONITOR_RESTART_SUCCESS: "El monitor fue reiniciado con éxito.",
  MONITOR_RESTART_FAILURE: "Ocurrió un error al reiniciar el monitor.",

  NTP_INFO_TURNED_OFF_FAILURE: "Ocurrió un error al apagar el servidor NTP.",
  NTP_INFO_FAILURE: "Error al sincronizar con el servidor. Si el error persiste, comuníquese con el administrador del servidor NTP.",

  SEND_WLAN_CONFIG_WAITING: "Enviando las configuraciones, por favor espere. Esto puede tardar alrededor de un minuto.",
  UPDATE_WLAN_CONFIG_ERROR: "No fue posible conectarse a la red WLAN. Si el problema persiste, intente reiniciar el monitor o el router WLAN.",

  ALTER_MONITOR_CONFIG: "¿Está seguro de que desea cambiar las configuraciones del monitor?",
  IP: "IP",
  EDIT: "Editar",
  CLEAR: "Limpiar",
  ALTER: "Cambiar",
  REPORT: "Informe",
  ALTER_LOGIN: "Cambiar inicio de sesión",
  SEND: "Enviar",
  GSD_FILES: "Archivos GSD",
  SOFTWARE_UPDATE: "Actualización de Software",
  CURRENT_VERSION: "Versión actual: ",
  UPDATE: "Actualizar",

  TEST_NETWORK: "Red de prueba",
  USER: "Usuario",
  NEW_PASSWORD: "Nueva contraseña",
  REPEAT_PASSWORD: "Repetir contraseña",
  TIMEZONE: "Timezone",
  DHCP: "DHCP",
  FIXED_IP: "IP Fija",

  // ---------------------------- WLAN Config ----------------------------
  WLAN_STATUS: "Adaptador WLAN",
  WLAN_CONFIG: "Configuraciones WLAN",
  CONNECTION_STATUS: "Estado de la conexión",

  WLAN_ADAPTER_ON: "Encendido",
  WLAN_ADAPTER_OFF: "Apagado",

  IP_PLACEHODLER: "192.168.2.215",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Intensidad de la señal",
  FREQUENCY: "Frecuencia",
  CHANNEL: "Canal",
  QUALITY: "Calidad",

  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Calidad",

  TURNING_WLAN_OFF_WAITING: "Apagando el adaptador WLAN, por favor espere.",
  TURNING_WLAN_ON_WAITING: "Encendiendo el adaptador WLAN, por favor espere.",

  NETWORK: "Red",
  NETWORK_NAME_1: "Nombre de la red",
  SUBMASK: "Máscara",
  GATEWAY: "Gateway",
  PASSWORD: "Contraseña",

  ALTER_MONITOR_WLAN_CONFIG: "¿Está seguro de que desea cambiar las configuraciones WLAN del monitor?",

  CONNECTED: "Conectada",
  DISCONNECTED: "Desconectada",

  WLAN_STATUS_POPUP_1: "Indica el estado del adaptador WLAN del monitor.",
  WLAN_STATUS_POPUP_2: "Si está apagado, no es posible cambiar las configuraciones WLAN.",

  CONNECTION_STATUS_POPUP_1: "Indica si el monitor está conectado o no a la red WLAN configurada.",

  WLAN_CONFIG_POPUP_1: "No es posible cambiar las configuraciones mientras el adaptador WLAN esté apagado.",
  WLAN_CONFIG_POPUP_2: "Se recomienda encarecidamente que las configuraciones WLAN se cambien solo al acceder al monitor a través de la red cableada.",
  WLAN_CONFIG_POPUP_3: "Al cambiar la IP / máscara, si los campos aparecen en blanco después de la actualización, esto es una fuerte indicación de que:",
  WLAN_CONFIG_POPUP_4: "Ya existe otro dispositivo en la red con la misma IP;",
  WLAN_CONFIG_POPUP_5: "La máscara de red es muy restrictiva y no admite la IP proporcionada.",

  WLAN_ADAPTER_NOT_FOUND_1: "El TS Monitor PROFIBUS PRO no pudo encontrar el adaptador WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Verifique si el adaptador está desconectado o con mal contacto;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • Si el adaptador no está desconectado ni con mal contacto, intente reemplazarlo;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • Si ninguna de las opciones anteriores resuelve el problema, comuníquese con Toledo e Souza.",

  LOADING_WAITING: "Cargando información, por favor espere.",
  WLAN_INFO: "Información WLAN",
  MAC: "MAC",
  DNS: "DNS",

  ALTER_MONITOR_HOSTNAME_CONFIRM_1: "¿Está seguro de que desea cambiar el hostname?",
  ALTER_MONITOR_HOSTNAME_CONFIRM_2: "Para ello es necesario reiniciar el monitor.",
  HOSTNAME_POPUP_1: "Un hostname debe tener entre 2 y 64 caracteres para ser válido.",
  HOSTNAME_POPUP_2: "Además, solo puede contener letras, números, puntos y guiones, y debe comenzar y terminar únicamente con letras y números.",
  INVALID_HOSTNAME_1: "El hostname debe tener entre 2 y 64 caracteres.",
  INVALID_HOSTNAME_2: "El hostname debe contener solo letras, números, puntos y guiones, y debe comenzar y terminar únicamente con letras y números.",
  HOSTNAME_CONFIG_SUCCESS: "El hostname fue configurado con éxito.",
  HOSTNAME_CONFIG_ERROR: "Ocurrió un error al configurar el hostname",
  MODE: "Modo",
  HIDDEN_SSID: "SSID Oculto",
  OPTIONAL: " (Opcional)",

  // ---------------------------- Edit Tags page related ----------------------------
  ADD_ALTER_TAGS: "Agregar/Cambiar Tags",
  CHOOSE_DEVICE: "Elija un dispositivo",
  NEW_TAG: "Nueva TAG",
  SAVE: "Guardar",
  REMOVE_ALL_TAGS: "Eliminar todas las Tags",
  REMOVE: "Eliminar",
  CONFIRM_REMOVE_ALL_TAGS: "¿Está seguro de que desea eliminar las tags de todos los dispositivos?",
  CHANGE_TAG_SUCCESS: "La tag fue modificada con éxito.",
  CHANGE_TAG_FAILURE: "Ocurrió un error al cambiar la tag",
  REMOVE_TAG_SUCCESS: "Las tags fueron eliminadas con éxito.",
  REMOVE_TAG_FAILURE: "Ocurrió un error al eliminar las tags",
  IMPORT_TAGS_SUCCESS: "Las tags fueron importadas con éxito",
  IMPORT_TAGS_FAILURE: "Ocurrió un error al importar las tags: ",
  PLEASE_SELECT_TAG_FILE: "Por favor seleccione un archivo de tags.",
  IMPORT_TAGS: "Importar tags",
  EXPORT_TAGS: "Exportar tags",

  MASTER_HASH: "Maestro #",
  SLAVE_HASH: "Esclavo #",

  // ---------------------------- Edit GSD page related ----------------------------
  REMOVE_GSD_SUCCESS: "Los archivos GSD fueron eliminados con éxito",
  REMOVE_GSD_FILES: "Gestionar archivos GSD",
  SELECT_AT_LEAST_ONE_FILE_TO_DELETE: "Por favor seleccione al menos un archivo para eliminar",
  REMOVING_GSD_FILES: "Eliminando archivos GSD",
  FILTER_GSD_FILES: "Filtrar archivos GSD",

  SELECT_ALL: "Seleccionar todos",
  REMOVE_SELECTED: "Eliminar seleccionados",

  // ---------------------------- Blacklist page related ----------------------------
  ADD_DEVICES_TO_BLACKLIST_FAILURE: "Ocurrió un error al agregar los esclavos a la blacklist.",

  REMOVE_DEVICES_FROM_BLACKLIST_FAILURE: "Ocurrió un error al eliminar los esclavos de la blacklist.",

  REMOVE_CRITIC_DEVICES_FROM_BLACKLIST_FAILURE: "Ocurrió un error al eliminar los esclavos de la lista de esclavos críticos.",

  BLACKLIST_FORM_INPUT_PLACEHOLDER: "Filtrar dispositivos por dirección, tag o modelo",
  BLACKLIST_ADDRESS: "Dirección",
  BLACKLIST_TAG: "Tag",
  BLACKLIST_MODEL: "Modelo",
  BLACKLIST_CRITICAL_SLAVE: "Esclavo crítico",
  UPDATE_BLACKLIST: "Actualizar blacklist",
  UPDATING_BLACKLIST_DATA: "Actualizando información, espere",

  BLACKLIST_HEADER_CELL_POPUP: "Impide el registro de logs de determinado equipo para no generar eventos repetitivos o no deseados.",
  BLACKLIST_HEADER_CELL_POPUP_2: "El esclavo en Blacklist no altera el estado de la red en la pestaña Resumen. Sus fallas, reintentos y diagnósticos son contabilizados.",

  AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP: "Los esclavos que presentan grandes cantidades de eventos se insertan automáticamente en la lista de esclavos críticos. Sus eventos dejan de guardarse para no saturar el log, pero sus fallas, reintentos y diagnósticos son contabilizados.",
  AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP_2: "El usuario puede eliminar esclavos críticos, pero no agregarlos.",
  AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP_3: "Si existe al menos un esclavo crítico en la lista, este cambia el estado de la red a ESCLAVO CRÍTICO en la pestaña Resumen.",

  ADD_BLACKLIST_CONFIRM_TEXT: "¿Está seguro de que desea aplicar los cambios a la blacklist y a la lista de esclavos críticos?",

  // ---------------------------- PDF Report ----------------------------
  PROFIBUS: "PROFIBUS",

  REPORT_EXPORT_NAME: "Informe TS Monitor PROFIBUS PRO",
  HEADER_TEXT: "Informe de datos - TS Monitor PROFIBUS PRO - Protocolo",

  GENERATING_REPORT_WAITING: "Generando informe, por favor espere",
  GENERATING_REPORT_SUCCESS: "Informe generado con éxito. Para guardarlo, haga clic en guardar informe abajo.",

  CONFORMITY: "Conformidad",
  DROPDOWN_PLACEHOLDER: "Elija una opción",
  GENERATE_REPORT: "Generar informe",

  GENERAL_REPORT: "Informe general – TS Monitor PROFIBUS PRO",
  DATA_REPORT: "Informe de datos – TS Monitor PROFIBUS PRO",

  MONITORING_INFO: "Información del monitoreo",
  ETHERNET_INFO: "Información ETHERNET",

  IP_DP: "- IP: ",
  MASK_DP: "- Máscara: ",
  GATEWAY_DP: "- Gateway: ",

  CLIENT_INFO: "Información del cliente",
  EXECUTING_COMPANY_INFO: "Información de la empresa ejecutora",
  ANNOTATIONS: "Anotaciones",
  CONCLUSION: "Conclusión",

  CONFORM_STRING: "Conforme",
  CONFORM_W_RESTRICTION_STRING: "Conforme con restricciones",
  NON_CONFORM_STRING: "No conforme",

  PROJECT_NAME: "- Nombre del proyecto:",
  NETWORK_NAME: "- Nombre de la red:",
  LOCATION: "- Ubicación:",
  COMPANY_NAME: "- Nombre de la empresa:",
  ACCOUNTABLE_NAME: "- Nombre del responsable:",
  COMPANY_ADDRESS: "- Dirección:",
  COMPANY_CITY: "- Ciudad:",
  COMPANY_TEL: "- Teléfono:",

  EXECUTING_COMPANY_NAME: "- Nombre de la empresa:",
  EXECUTING_ACCOUNTABLE_NAME: "- Nombre del responsable:",
  EXECUTING_TEL: "- Teléfono:",
  EXECUTING_EMAIL: "- Email:",

  NETWORK_NAME_DP: "- Nombre de la red: ",
  TAG_NAME_DP: "- Tag de la red: ",
  MONITOR_VERSION_DP: "- Versión del monitor: ",
  MONITOR_INIT_DP: "- Inicio del monitoreo: ",
  GENERATING_TIME_DP: "- Generación del informe: ",
  DURATION_SINCE_MON_BEGIN: "- Duración del monitoreo hasta la generación del informe: ",

  TS_MONITOR_VER_DP: "TS Monitor PROFIBUS PRO - Versión ",
  NETWORK_AVAILABILITY_DP: "Disponibilidad de la red: ",
  BAUD_RATE_DP: "Baud rate: ",
  CYCLE_TIME_DP: "Tiempo de ciclo: ",
  DEVICE_DATA: "Datos de los dispositivos",
  MASTERS_DP: "Maestros: ",
  SLAVES_DP: "Esclavos: ",
  ONLINE_SLAVES_DP: "Esclavos online: ",
  MISSING_DP: "Ausentes: ",
  RETRIES_DP: "Reintentos: ",
  DIAGNOSTIC_DP: "Diagnósticos: ",
  FAULT_DP: "Fallas: ",
  WATCHDOG_DP: "Watchdog: ",
  RETRIES_LIMIT_DP: "Límite de reintentos: ",
  HSA_DP: "HSA: ",

  SUMMARY: "Sumario",
  RESUME: "Resumen",
  LIVE_LIST: "Live List",
  LOG: "Log",
  MATRIX: "Matriz",
  GRAPHIC_TOPOLOGY: "Topología gráfica",
  CONFIG_STRING: "Configuraciones",

  RESUME_DOTS: ".....................................................................................................................................",
  LIVE_LIST_DOTS: ".......................................................................................................................................",
  MON_LOG_DOTS: "...............................................................................................................................................",
  DISCLAIMER_DOTS: "...................................................................................................................................",

  M_MONITORING_RESUME_PAGE_TITLE: "1.1. - Resumen",
  M_MONITORING_LIVE_LIST_PAGE_TITLE: "1.2. Live List",
  M_MONITORING_LOG_PAGE_TITLE: "1.3. - Log",

  ADDRESS: "Dirección",
  MODEL: "Modelo",

  LAST_200_EVENTS: "Últimos 200 eventos",
  HORARY: "Horario",
  DESCRIPTION: "Descripción",

  END_OF_REPORT: "Fin del informe",
  DISCLAIMER: "Aviso legal",
  DISCLAIMER_TEXT: "Los datos y valores presentados en este informe son meramente auxiliares para el especialista en PROFIBUS, de modo que cualquier indicación de corrección debe ser realizada por el usuario. Por esta razón, se recomienda el acompañamiento de un ingeniero certificado en PROFIBUS o del técnico responsable del análisis para validar la información proporcionada por el producto. Por lo tanto, Toledo & Souza se exime de cualquier responsabilidad, pérdida o daño, directo o indirecto, causado por las interpretaciones del software, no ofreciendo ninguna garantía respecto a la integridad, calidad o adecuación de la información proporcionada, ya que esta depende del análisis técnico de un profesional capacitado; a falta de este, el usuario asumirá el riesgo de que el contenido pueda ser impreciso, incompleto o no satisfacer sus necesidades y requisitos.",

  DIAGNOSTIC_STRING: "Diagnóstico",
  ONLINE_STRING: "Online",
  MISSING_PLURAL_STRING: "Ausentes",
  MISSING_SINGULAR_STRING: "Ausente",
  CONFIG_ERROR_STRING: "Error de configuración",
  PARAM_ERROR_STRING: "Error de parametrización",
  FAULT_STRING: "Falla",
  BLACKLIST_STRING: "Blacklist",
  CRITIC_SLAVE_STRING: "Esclavo crítico",
  MASTER_FAULT_STRING: "Maestro",
  SLAVE_MASTER_FAULT_STRING: "Maestro en falla",
  MPI_STRING: "MPI",
  MPI_CSV_FAULT_STRING: "MPI en falla",
  MASTER_CLASS_2: "Maestro",
  MASTER_OPERATE: "Maestro - operate",
  MASTER_SYNC: "Maestro - sync",
  MASTER_UNSYNC: "Maestro - unsync",
  MASTER_FREEZE: "Maestro - freeze",
  MASTER_UNFREEZE: "Maestro - unfreeze",
  MASTER_CLEAR: "Maestro - clear",
  CLASS_2: "",
  MASTER_OPERATE_CAPITAL: "Maestro - Operate",
  MASTER_SYNC_CAPITAL: "Maestro - Sync",
  MASTER_UNSYNC_CAPITAL: "Maestro - Unsync",
  MASTER_FREEZE_CAPITAL: "Maestro - Freeze",
  MASTER_UNFREEZE_CAPITAL: "Maestro - Unfreeze",
  MASTER_CLEAR_CAPITAL: "Maestro - Clear",

  // ---------------------------- OTHERS ----------------------------
  BEFORE_MONITOR_INIT_STR: "Anterior al último inicio",
  REMOVE_DEVICE_SUCCESS: "El dispositivo será eliminado en hasta 30 segundos.",
  REMOVE_DEVICE_FAILURE: "Ocurrió un error al eliminar el dispositivo: ",

  OK_STRING: "OK",
  WITH_DIAGNOSTIC_STRING: "La red tiene esclavos en diagnóstico",
  WITH_FAILURE_STRING: "La red tiene esclavos en falla",
  WITH_CRITICAL_SLAVE_STRING: "La red tiene esclavos en estado crítico",
  WITH_MASTER_FAULT_STRING: "La red tiene maestros en falla",
  UNKNOWN: "Desconocido",
  LOG_WAITING: "Cargando datos del log",
  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filtrar por dirección o estado",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filtrar por dirección, tag, modelo o \"Evento de la red\"",
  OPTIC_FIBER_LOG_INPUT_TEXT_PLACEHOLDER: "Filtrar por tipo de evento",
  OPTIC_FIBER_INSERT_VALID_TYPE: "Por favor, escriba un tipo de evento válido.",
  SLAVE_DIAGNOSTIC: "Diagnóstico del esclavo:",
  STATUS_CHANGE: "Cambio de estado: ",
  NETWORK_EVENT: "Evento de la red",
  MASTER_HASHTAG: "Maestro #",
  CONFIG_ERROR_1: "Error de ",
  CONFIG_ERROR_2: "configuración",
  PARAM_ERROR_1: "Error de ",
  PARAM_ERROR_2: "parametrización",
  LAST_EVENT: "Último evento: ",
  MODEL_: "Modelo: ",

  DIAGNOSTICS_STRING: "Diagnósticos",
  RETRIES_STRING: "Reintentos",
  NO_FAULTS_STRING: "sin fallas",
  TOTAL: "totales",
  RETRIES_NO_FAULT_STRING: "Reintentos sin fallas",
  FAULTS_STRING: "Fallas",
  WATCHDOG_STRING: "Watchdog",
  BILLION_OF: "Mil millones de",
  BILLIONS_OF: "Miles de millones de",
  MILLION_OF: "Millón de",
  MILLIONS_OF: "Millones de",
  THOUSAND: "Mil",
  LAST_EVENT_TOO_BIG_STRING: "Descripción muy larga, por favor consulte el log.",
  CRITICAL_SLAVE_EXPLANATION: "El TS Monitor posee una función automática para seleccionar los esclavos que tengan un número excesivo de eventos e informar al usuario que este dispositivo es crítico para la red PROFIBUS.",
  DIAGNOSTICS_QUESTION_INFO: " Indica el número de diagnósticos detectados en la red PROFIBUS. Los diagnósticos indican condiciones anormales del estado del dispositivo, como cortocircuito, problema de alimentación, falta de módulo, etc.",
  RETRIES_QUESTION_INFO: "Indica el número de veces que el maestro necesitó reenviar un mensaje a determinado equipo después de no recibir respuesta. Generalmente indica problemas en la capa física.",
  NOT_RETRIES_QUESTION_INFO: "El reintento sin falla nos ayuda a verificar problemas de red que aún no causaron la caída del dispositivo. También, desconsidera las caídas que ocurrieron por apagado o desconexión.",

  FAULTS_QUESTION_INFO: "Indica el número de veces que determinado equipo PROFIBUS dejó de responder a los mensajes del maestro.",

  WATCHDOG_QUESTION_INFO_1: "El watchdog es el tiempo que el esclavo espera después de perder la comunicación con el maestro antes de cambiar sus salidas a la condición de seguridad.",
  WATCHDOG_QUESTION_INFO_2: "Este parámetro es enviado por el maestro a todos los esclavos de la red, individualmente, en su respectivo telegrama de parametrización.",
  WATCHDOG_QUESTION_INFO_3: "Si el tiempo de ciclo está próximo al watchdog, la red queda más vulnerable.",
  WATCHDOG_QUESTION_INFO: "Indica si el watchdog del dispositivo está activo, inactivo o si aún no fue parametrizado.",

  // ---------------------------- GRAPHIC TOPOLOGY ----------------------------
  GRAPHIC_TOPOLOGY_INPUT_PLACEHOLDER: "Buscar dispositivo por dirección o tag",

  EDIT_TOPOLOGY_POS_STRING: "Editar",
  EDIT_EDGE_TYPE: "Editar tipo de conexión",
  SAVE_TOPOLOGY_POS_STRING: "Guardar",
  DELETE_TOPOLOGY_POS_STRING: "Eliminar",
  EXPORT_SVG: "SVG",

  EXPORT_TOPOLOGY: "Topología",
  IMPORT: "Importar",
  IMPORT_TOPOLOGY: "Importar Topología",
  POSITION: "Posición",
  EXPORT: "Exportar",

  SAVE_TOPOLOGY_POS_SUCCESS_STRING: "¡La posición de la topología fue guardada con éxito!",
  SAVE_TOPOLOGY_POS_FAILURE_STRING: "Ocurrió el siguiente error al guardar la posición de la topología: ",

  DROP_TOPOLOGY_POS_SUCCESS_STRING: "¡La posición de la topología fue eliminada con éxito!",
  DROP_TOPOLOGY_POS_FAILURE_STRING: "Ocurrió el siguiente error al eliminar la posición de la topología: ",

  ASK_REMOVE_POSITIONING: "¿Está seguro de que desea eliminar la posición guardada?",
  REMOVE_POSITIONING: "Eliminar posicionamiento",

  YES: "Sí",
  NO: "No",

  ALERT_NOT_POSSIBLE_TO_EDIT: "No es posible editar datos del maestro",
  ALERT_NOT_POSSIBLE_TO_EDIT_SCOPE: "No es posible editar los datos del TS Scope",
  ALERT_NOT_POSSIBLE_TO_DELETE: "No es posible eliminar un dispositivo de la live list",
  ALERT_CHOOSE_DEVICE_TYPE: "Por favor elija un tipo de dispositivo",
  ALERT_CHOOSE_CONNECTION_TYPE: "Por favor seleccione un tipo de conexión",

  ADD_DEVICE: "Agregar dispositivo",
  TAG_PLACEHOLDER: "TAG (opcional)",

  DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER: "Elija un tipo de dispositivo",
  ADD_CONNECTION: "Agregar conexión",
  CONNECTION_DEFAULT_DROPDOWN_PLACEHOLDER: "Elija un tipo de conexión",
  EDIT_DEVICE: "Editar dispositivo",

  CANCEL: "Cancelar",
  ADD: "Agregar",

  MASTER_NAME: "Maestro",
  SLAVE_NAME: "Esclavo",
  SLAVE_PA_NAME: "Esclavo PA",
  REPEATER_NAME: "Repetidor",
  HUB_NAME: "Hub",
  JB_NAME: "Junction Box",
  COUPLER_PROXY_NAME: "Coupler/Proxy",
  FIBER_LINK_NAME: "Enlace de fibra",
  ACTIVE_TERMINATION_NAME: "Terminador activo",
  UNKNOWN_NAME: "Desconocido",
  TS_MONITOR_NAME: "TS Monitor",
  TS_MONITOR_PRO_NAME: "TS Monitor PRO",
  MPI_NAME: "MPI",
  TS_SCOPE_DP_NAME: "TS Scope DP",
  TS_SCOPE_PA_NAME: "TS Scope PA",

  LOCALE_EDIT: "Editar",
  LOCALE_DEL: "Eliminar seleccionado",
  LOCALE_BACK: "Volver",
  LOCALE_ADD_NODE: "Agregar dispositivo",
  LOCALE_ADD_EDGE: "Agregar conexión",
  LOCALE_EDIT_NODE: "Editar dispositivo",
  LOCALE_EDIT_EDGE: "Editar conexión",
  LOCALE_ADD_DESCRIPTION: "Haga clic en un espacio en blanco para agregar un nuevo dispositivo",
  LOCALE_EDGE_DESCRIPTION: "Haga clic en un dispositivo y arrastre la conexión hasta otro dispositivo para conectarlos",
  LOCALE_EDIT_EDGE_DESCRIPTION: "Haga clic en los puntos de control y arrástrelos a un dispositivo para conectarlos",
  LOCALE_CREATE_EDGE_ERROR: "No es posible crear conexión para un clúster",
  LOCALE_DELETE_CLUSTER_ERROR: "Los clústeres no pueden ser eliminados",
  LOCALE_EDIT_CLUSTER_ERROR: "Los clústeres no pueden ser editados",

  FORM_NO_DEVICE_FOUND_PREFIX: "El dispositivo con dirección ",
  FORM_NO_DEVICE_FOUND_SUFFIX: " no fue encontrado",

  INSERT_VALID_ADDRESS_OR_TAG: "Por favor ingrese una dirección o tag válidas",
  INSERT_VALID_ADDRESS0_TAG_OR_MODEL: "Por favor ingrese una dirección, tag o modelo válidos",

  POSITIONING_CONFLICT_1: "Hay un conflicto en la información de los dispositivos con direcciones:",
  POSITIONING_CONFLICT_2: "\nDebido a esto, sus posiciones y conexiones volverán al estado predeterminado.",
  POSITIONING_ANG_CONNECTIONS_RESET_SUCCESS: "Las posiciones y conexiones volvieron al estado predeterminado con éxito",
  POSITIONING_ANG_CONNECTIONS_RESET_FAILURE: "Ocurrió el siguiente error al restablecer las posiciones y conexiones al estado predeterminado: ",

  TOPOLOGY_IMPORT_SUCCESS: "¡La topología fue importada con éxito!",
  ERROR_IMPORTING_GRAPHIC_TOPOLOGY: "Ocurrió un error al importar la topología gráfica: ",
  INVALID_OR_CORRUPT_FILE: "El archivo no es válido o está corrupto.",
  PLEASE_SELECT_TOPOLOGY_FILE: "Por favor seleccione un archivo de topología.",

  COLORS_LABELS: "Leyenda de colores",
  LABEL_SLAVE_OK_MASTER_OP: ": Esclavo ok, y maestro en operate;",
  LABEL_MASTER_STOP_CLEAR: ": Maestro en STOP / CLEAR;",
  LABEL_SLAVE_DIAG: ": Esclavo en diagnóstico;",
  LABEL_SLAVE_N_MASTER_FAULT: ": Esclavo en falla, y maestro en falla;",
  LABEL_SLAVE_CONFIG_ERROR: ": Esclavo con error de configuración;",
  LABEL_SLAVE_PARAM_ERROR: ": Esclavo con error de parametrización;",
  LABEL_SLAVE_ONLINE: ": Esclavo online;",
  LABEL_SLAVE_MISSING: ": Esclavo ausente;",
  LABEL_SLAVE_MASTER_FAULT: ": Esclavo con maestro en falla;",
  LABEL_SLAVE_BLACKLIST: ": Esclavo en blacklist;",
  LABEL_CRITICAL_SLAVE: ": Esclavo crítico;",
  LABEL_MPI: ": MPI;",
  LABEL_NO_STATUS: ": Dispositivo sin estado.",

  DEVICE_TAG_NOT_FOUND: "No se encontró ningún dispositivo con la TAG: ",

  INSERT_VALID_ADDRESS_1_127: "Ingrese una dirección de esclavo válida, entre 1 y 127.",
  DEVICE_WITH_ADDRESS: "El dispositivo con dirección ",
  WAS_SUCCESSFULLY_ADDED: " fue agregado con éxito.",
  WAS_SUCCESSFULLY_REMOVED: " fue eliminado con éxito.",
  IS_ALREADY_IN_NETWORK: " ya está en la red.",
  REMOVE_DEVICE_ERROR: "Ocurrió el siguiente error al intentar eliminar el dispositivo: ",

  TS_SCOPE_NOT_FOUND: "No fue posible encontrar el TS Scope con IP:",
  INVALID_INSERTED_IP: "La IP ingresada es inválida",
  TS_SCOPE_FETCH_SUCCESS: "La obtención del TS Scope fue exitosa",

  // ---------------------------- TS EXPERT CONFIG ----------------------------
  TS_EXPERT: "TS Expert",
  SETUP: "Configurar",

  TS_EXPERT_CONFIGURATION: "Configuraciones de TS Expert",
  SENDING_TS_EXPERT_CONFIG_WAITING: "Actualizando las configuraciones de TS Expert, espere un instante.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "Las configuraciones de TS Expert fueron guardadas con éxito.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "Ocurrió un error al guardar las configuraciones de TS Expert.",

  CONFIG_RETRIES_LIST_HEADER: "Reintentos sin falla",
  CONFIG_RETRIES_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará los reintentos que no llevaron a falla, por dispositivo. El reintento sin falla nos ayuda a verificar problemas de red que aún no causaron la caída del dispositivo. También, desconsidera las caídas que ocurrieron por apagado o desconexión.",

  CONFIG_DIAGNOSTIC_LIST_HEADER: "Diagnósticos",
  CONFIG_DIAGNOSTIC_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará todos los diagnósticos, por dispositivo.",

  CONFIG_FAULT_LIST_HEADER: "Fallas",
  CONFIG_FAULT_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará todas las fallas, por dispositivo.",

  CONFIG_FAULT_SEQUENCE_LIST_HEADER: "Secuencia de fallas",
  CONFIG_FAULT_SEQUENCE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert registrará todas las fallas que ocurrieron en secuencia en caso de fallas de diversos dispositivos.",

  CONFIG_CONFIG_ERROR_LIST_HEADER: "Error de configuración",
  CONFIG_CONFIG_ERROR_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará todos los dispositivos que presentan error de configuración.",

  CONFIG_PARAM_ERROR_LIST_HEADER: "Error de parametrización",
  CONFIG_PARAM_ERROR_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará todos los dispositivos que presentan error de parametrización.",

  CONFIG_MISSING_LIST_HEADER: "Esclavo ausente",
  CONFIG_MISSING_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará todos los esclavos ausentes.",

  CONFIG_ONLINE_LIST_HEADER: "Esclavo online",
  CONFIG_ONLINE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará todos los esclavos online.",

  CONFIG_CRITICAL_SLAVE_LIST_HEADER: "Esclavo crítico",
  CONFIG_CRITICAL_SLAVE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert registrará todos los esclavos críticos.",

  CONFIG_MASTER_FAULT_LIST_HEADER: "Maestro en falla",
  CONFIG_MASTER_FAULT_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará cuando TS Monitor no esté recibiendo frames PROFIBUS.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_HEADER: "Link de fibra óptica – Falla en el nivel de tensión (Acción requerida)",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará baja tensión en las salidas analógicas que indican la calidad de la señal recibida por el link de fibra. Este valor puede ser configurado por el usuario en la pantalla de configuración de su TS Scope/Monitor PRO.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_HEADER: "Link de fibra óptica – Falla en el nivel de tensión (Acción urgente)",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará baja tensión en las salidas analógicas que indican la calidad de la señal recibida por el link de fibra. Este valor puede ser configurado por el usuario en la pantalla de configuración de su TS Scope/Monitor PRO.",

  FIBER_SIGNAL_LOSS_LIST_HEADER: "Link de fibra óptica – Falla por relé",
  FIBER_SIGNAL_LOSS_LIST_CONTENT: "Cuando esta opción está activada, TS Expert mostrará falla en el link de fibra indicada por relé, que debe estar conectado al TS Scope/Monitor PRO.",

  // ---------------------------- TS EXPERT ----------------------------
  TS_EXPERT_REPORT_EXPORT_NAME: "Lista de acciones - TS Expert - Monitor PROFIBUS PRO",

  TS_EXPERT_POPUP_1: "En esta pestaña se presenta la información de TS Expert.",
  TS_EXPERT_POPUP_2: "Esta herramienta es un sistema experto desarrollado para optimizar y acelerar el análisis de las principales divergencias detectadas por TS Monitor en redes PROFIBUS.",
  TS_EXPERT_POPUP_3: "De forma automatizada, mantenimiento, ingeniería y equipos relacionados pueden obtener una lista de acciones con diferentes eventos, sus posibles causas, sugerencias de solución y los dispositivos en los que fueron detectados.",
  TS_EXPERT_POPUP_4: "El uso de TS Expert no excluye la necesidad del análisis humano ni sustituye dichas capacidades de crear correlaciones de datos e interpretación.",

  DETECTED_ON: "Detectado en: ",
  CHECK_YOUR_NETWORK: "Por favor verifique su red.",

  EXPORT_ACTIONS_LIST: "Exportar lista de acciones",
  GENERATING_ACTIONS_LIST_WAITING: "Generando PDF de lista de acciones, por favor espere.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF generado con éxito. Para guardarlo, haga clic en guardar lista de acciones.",

  EVENTS_LIST: "Lista de eventos",
  ACTIONS: "Acciones",

  NO_PROBLEM_DETECTED: "TS Expert no detectó ningún evento en la red.",
  NO_EVENTS_TO_BE_ANALYZED: "No hay eventos para analizar.",

  NO_EVENT_SELECTED: "Ningún evento seleccionado",
  CHOOSE_AN_EVENT: "Elija un evento para visualizar las acciones sugeridas.",

  DETAILING: "Detalle",

  CHECKED: "Revisado",
  BATCH_CHECK: "Revisar todos",

  PROBLEM_CHECKED: "El evento fue revisado con éxito",
  PROBLEM_CHECK_ERROR: "Ocurrió un error al revisar el evento.",

  LAST_UPDATED: "Actualizado por última vez el: ",
  THIS_COMPUTER_TIME: " (Hora de esta computadora)",

  DEVICE: "Dispositivo",

  // ---------------------------- RETRIES (TS EXPERT) ----------------------------
  RETRIES_LIST_HEADER: "Existen dispositivos en la red que tienen reintentos sin fallas.",
  DEVICE_WITH_RETRIES: "Dispositivo con reintentos sin fallas",

  RETRIES_INITIAL_ERROR_MSG: "No fue posible revisar los eventos de los siguientes dispositivos, ya que aún tienen reintentos:\n",
  S_RETRIES_INITIAL_ERROR_MSG: "No fue posible revisar el evento del dispositivo, ya que aún tiene reintentos\n",

  RETRIES_SUGGESTION_1: "Cuando un dispositivo tenga reintentos sin fallas se sugiere:",
  RETRIES_SUGGESTION_2: "Los reintentos sin fallas indican el número de veces que el maestro necesitó reenviar un mensaje a determinado equipo después de no recibir respuesta, ya sea porque el esclavo no respondió o porque la respuesta estaba corrompida (frame ilegal o incompleto), por efecto de ruido, bajo aislamiento en el esclavo o en la infraestructura del bus. El reintento sin falla nos ayuda a verificar problemas de red que aún no causaron la caída del dispositivo. También, desconsidera las caídas que ocurrieron por apagado o desconexión.",
  RETRIES_SUGGESTION_3: "Verificar y corregir el montaje del conector. El TDC-1000 puede ayudarle en esta tarea;",
  RETRIES_SUGGESTION_4: "Verificar daños en el cable PROFIBUS, como:",
  RETRIES_SUGGESTION_5: "Dobladuras menores que 10 veces el radio del conductor;",
  RETRIES_SUGGESTION_6: "Cortes en el cable;",
  RETRIES_SUGGESTION_7: "Torsiones en el cable;",
  RETRIES_SUGGESTION_8: "Aplastamientos en el cable.",
  RETRIES_SUGGESTION_9: "Estas no conformidades requieren el reemplazo del tramo de cable (no es posible solucionar la no conformidad desdoblando o desabollando el cable);",
  RETRIES_SUGGESTION_10: "Verifique si hay cables de potencia cerca de cables PROFIBUS. Los cables de datos como PROFIBUS deben estar separados lo más posible o en bandejas/canalizaciones cerradas y aterradas, siguiendo el mínimo indicado por las directrices según la clasificación del conductor eléctrico, norma EN50174;",
  RETRIES_SUGGESTION_11: "Medir la corriente de fuga en el cable con una pinza adecuada; si la medida es mayor a 100mA, es necesario verificar la equipotencialización y el sistema de puesta a tierra;",
  RETRIES_SUGGESTION_12: "Verificar la calidad de la señal con uno de los equipos de Toledo e Souza que disponga de osciloscopio, el cual le dará indicaciones según las mediciones realizadas;",
  RETRIES_SUGGESTION_13: "Si ninguno de los puntos anteriores resuelve el problema, y un determinado equipo está presentando reintentos de manera aislada (solo un esclavo específico presenta reintentos), se sugiere reemplazar la interfaz de red del esclavo.",
  RETRIES_SUGGESTION_14: "El único punto que puede dar mejor resultado con la planta en funcionamiento es el punto “d”; sin embargo, el uso del equipo de Toledo e Souza que dispone de osciloscopio debe realizarse con cautela, pues si la condición de la señal está muy comprometida puede hacer caer la red.",

  // ---------------------------- DIAGNOSTIC (TS EXPERT) ----------------------------
  DIAGNOSTIC_LIST_HEADER: "Existen dispositivos en la red que tienen diagnósticos.",
  DEVICE_WITH_DIAGNOSTIC: "Dispositivo con diagnósticos",

  DIAGNOSTIC_INITIAL_ERROR_MSG: "No fue posible revisar los eventos de los siguientes dispositivos, ya que aún tienen diagnósticos:\n",
  S_DIAGNOSTIC_INITIAL_ERROR_MSG: "No fue posible revisar el evento del dispositivo, ya que aún tiene diagnósticos\n",

  DIAGNOSTIC_SUGGESTION_1: "Cuando un dispositivo tenga diagnósticos se sugiere:",
  DIAGNOSTIC_SUGGESTION_2: "El estado “Diagnóstico” es una información enviada por el esclavo al maestro; generalmente no es un problema de red, sino un aviso del esclavo indicando que necesita mantenimiento o sustitución. A continuación, la lista de acciones para resolver el problema:",
  DIAGNOSTIC_SUGGESTION_3: "Si un esclavo presenta diagnóstico, verifique la información enviada e intente solucionar el problema; si tiene dificultad para entender el diagnóstico, comuníquese con el fabricante del esclavo para aclarar sus dudas antes de una intervención;",
  DIAGNOSTIC_SUGGESTION_4: "El número creciente de diagnósticos sin datos de mantenimiento puede estar directamente relacionado con las fallas del dispositivo, pues cuando el equipo vuelve a comunicarse existe un diagnóstico de verificación, que comprueba si el esclavo está listo para el intercambio de datos. Verifique si el número de diagnósticos está próximo al de fallas; en ese caso, siga el procedimiento paso a paso para fallas.",

  // ---------------------------- FAULT (TS EXPERT) ----------------------------
  FAULT_LIST_HEADER: "Existen dispositivos en la red que tienen fallas.",
  DEVICE_WITH_FAULT: "Dispositivo con fallas",

  FAULT_INITIAL_ERROR_MSG: "No fue posible revisar los eventos de los siguientes dispositivos, ya que aún tienen fallas:\n",
  S_FAULT_INITIAL_ERROR_MSG: "No fue posible revisar el evento del dispositivo, ya que aún tiene fallas\n",

  FAULT_SUGGESTION_1: "Cuando un dispositivo tenga fallas se sugiere:",
  FAULT_SUGGESTION_2: "El estado “Falla” indica que el esclavo dejó de comunicarse, es decir, dejó de intercambiar datos con el maestro (cayó de la red). En este caso no es posible determinar el motivo de la falla, que puede ser, por ejemplo, la rotura de un cable o falta de alimentación eléctrica:",
  FAULT_SUGGESTION_3: "Verificar la alimentación del esclavo;",
  FAULT_SUGGESTION_4: "Verificar si está conectado a la red (cable o fibra óptica);",
  FAULT_SUGGESTION_5: "Verificar la integridad y el correcto montaje del conector;",
  FAULT_SUGGESTION_6: "Verificar la integridad del cable;",

  // ---------------------------- FAULT SEQUENCE (TS EXPERT) ----------------------------
  FAULT_SEQ_LIST_HEADER: "Existen dispositivos en la red que tienen secuencias de fallas.",
  DEVICE_WITH_FAULT_SEQ: "Dispositivo con secuencia de fallas",

  FAULT_SEQ_INITIAL_ERROR_MSG: "No fue posible revisar los eventos de los siguientes dispositivos, ya que aún tienen secuencia de errores:\n",
  S_FAULT_SEQ_INITIAL_ERROR_MSG: "No fue posible revisar el evento del dispositivo, ya que aún tiene secuencia de errores\n",

  FAULTS_SEQ_SUGGESTION_1: "En caso de una falla de dispositivos en secuencia se sugiere:",
  FAULTS_SEQ_SUGGESTION_2: "Verificar la alimentación de los esclavos que dejaron de comunicarse;",
  FAULTS_SEQ_SUGGESTION_3: "Verificar la calidad de la señal en el segmento del primer esclavo que dejó de comunicarse con uno de los equipos de Toledo e Souza que disponga de osciloscopio;",
  FAULTS_SEQ_SUGGESTION_4: "Verificar si están conectados a la red;",
  FAULTS_SEQ_SUGGESTION_5: "Verificar si algún terminador aislador fue activado accidentalmente;",
  FAULTS_SEQ_SUGGESTION_6: "Verificar los terminadores de red de este segmento;",
  FAULTS_SEQ_SUGGESTION_7: "Verificar la integridad del bus de este segmento;",
  FAULTS_SEQ_SUGGESTION_8: "Verificar fallas potenciales en repetidores, hubs o enlaces de fibra óptica.",

  // ---------------------------- CONFIG ERROR (TS EXPERT) ----------------------------
  CONFIG_ERROR_LIST_HEADER: "Existen dispositivos en la red con error de configuración.",
  DEVICE_WITH_CONFIG_ERROR: "Dispositivo con error de configuración",

  CONFIG_ERROR_INITIAL_ERROR_MSG: "No fue posible revisar los eventos de los siguientes dispositivos, ya que aún presentan error de configuración:\n",
  S_CONFIG_ERROR_INITIAL_ERROR_MSG: "No fue posible revisar el evento del dispositivo, ya que aún presenta error de configuración\n",

  CONFIG_ERROR_SUGGESTION_1: "Cuando un dispositivo tenga error de configuración se sugiere:",
  CONFIG_ERROR_SUGGESTION_2: "Ocurre cuando algún esclavo no aceptó la configuración realizada en el maestro o SDCD y no entró en intercambio de datos. Sugerencia:",
  CONFIG_ERROR_SUGGESTION_3: "Verifique la configuración en el software del maestro o SDCD;",

  // ---------------------------- PARAM ERROR (TS EXPERT) ----------------------------
  PARAM_ERROR_LIST_HEADER: "Existen dispositivos en la red con error de parametrización.",
  DEVICE_WITH_PARAM_ERROR: "Dispositivo con error de parametrización",

  PARAM_ERROR_INITIAL_ERROR_MSG: "No fue posible revisar los eventos de los siguientes dispositivos, ya que aún presentan error de parametrización:\n",
  S_PARAM_ERROR_INITIAL_ERROR_MSG: "No fue posible revisar el evento del siguiente dispositivo, ya que aún presenta error de parametrización\n",

  PARAM_ERROR_SUGGESTION_1: "Cuando un dispositivo tenga error de parametrización se sugiere:",
  PARAM_ERROR_SUGGESTION_2: "Ocurre cuando algún esclavo no aceptó la parametrización realizada en el maestro o SDCD y no entró en intercambio de datos. La parametrización es una verificación del ID Number del esclavo, es decir, puede ser que se haya instalado un esclavo diferente al declarado en el sistema. Sugerencia:",
  PARAM_ERROR_SUGGESTION_3: "Verifique si el esclavo declarado en el software del maestro o SDCD es el mismo que está instalado en campo.",

  // ---------------------------- MISSING (TS EXPERT) ----------------------------
  MISSING_LIST_HEADER: "Existen dispositivos ausentes en la red.",
  DEVICE_MISSING: "Dispositivo ausente",

  MISSING_INITIAL_ERROR_MSG: "No fue posible revisar los eventos de los siguientes dispositivos, ya que aún están ausentes:\n",
  S_MISSING_INITIAL_ERROR_MSG: "No fue posible revisar el evento del dispositivo, ya que aún está ausente\n",

  MISSING_SUGGESTION_1: "Cuando un dispositivo esté ausente se sugiere:",
  MISSING_SUGGESTION_2: "Ocurre cuando el maestro o SDCD está buscando un esclavo en la red, pero no recibe respuesta. Este esclavo fue configurado en el proyecto, pero no está respondiendo en la red o no está instalado. Sugerencia:",
  MISSING_SUGGESTION_3: "Verifique si el esclavo declarado en el software del maestro o SDCD está conectado a la red y alimentado.",
  MISSING_SUGGESTION_4: "No se recomienda dejar al maestro o SDCD buscando esclavos que no serán instalados.",

  // ---------------------------- ONLINE (TS EXPERT) ----------------------------
  ONLINE_LIST_HEADER: "Existen dispositivos online en la red.",
  DEVICE_ONLINE: "Dispositivo online",

  ONLINE_INITIAL_ERROR_MSG: "No fue posible revisar los eventos de los siguientes dispositivos, ya que aún están online:\n",
  S_ONLINE_INITIAL_ERROR_MSG: "No fue posible revisar los eventos del dispositivo, ya que aún está online\n",

  ONLINE_SUGGESTION_1: "Cuando un dispositivo esté online se sugiere:",
  ONLINE_SUGGESTION_2: "Ocurre cuando el maestro o SDCD encuentra un esclavo en la red, pero este no está configurado en el sistema. Sugerencia:",
  ONLINE_SUGGESTION_3: "Verifique si el esclavo debería estar fuera de la red o si debe ser configurado.",

  // ---------------------------- CRITICAL SLAVE (TS EXPERT) ----------------------------
  CRITICAL_SLAVE_LIST_HEADER: "Existen esclavos críticos en la red.",
  DEVICE_IS_CRITICAL_SLAVE: "El dispositivo es un esclavo crítico",

  CRITICAL_SLAVE_INITIAL_ERROR_MSG: "No fue posible revisar los eventos de los siguientes dispositivos, ya que aún son esclavos críticos:\n",
  S_CRITICAL_SLAVE_INITIAL_ERROR_MSG: "No fue posible revisar el evento del dispositivo, ya que aún es un esclavo crítico\n",

  CRITICAL_SLAVE_SUGGESTION_1: "Cuando existan esclavos críticos en la red se sugiere:",
  CRITICAL_SLAVE_SUGGESTION_2: "El TS Monitor posee una función automática para seleccionar los esclavos que tengan un número excesivo de eventos e informa al usuario que este dispositivo es crítico para la red PROFIBUS. Sugerencia:",
  CRITICAL_SLAVE_SUGGESTION_3: "Verifique la condición de instalación del esclavo;",
  CRITICAL_SLAVE_SUGGESTION_4: "Verificar la alimentación del esclavo;",
  CRITICAL_SLAVE_SUGGESTION_5: "Verificar si está conectado a la red de forma correcta;",
  CRITICAL_SLAVE_SUGGESTION_6: "Verificar la integridad y el correcto montaje del conector;",
  CRITICAL_SLAVE_SUGGESTION_7: "Verificar la integridad del cable;",
  CRITICAL_SLAVE_SUGGESTION_8: "Verificar la calidad de la señal del esclavo con uno de los equipos de Toledo e Souza que disponga de osciloscopio;",
  CRITICAL_SLAVE_SUGGESTION_9: "Si el análisis con el equipo con osciloscopio no aporta la solución, se sugiere reemplazar la interfaz de red.",
  CRITICAL_SLAVE_SUGGESTION_10: "Para sacar al esclavo de este estado es necesario entrar en configuraciones, luego en blacklist y desmarcar el checkbox.",

  // ---------------------------- MASTER FAULT (TS EXPERT) ----------------------------
  MASTER_FAULT_LIST_HEADER: "Existen maestros en falla en la red.",
  DEVICE_IS_MASTER_FAULT: "El dispositivo es un maestro en falla",

  MASTER_FAULT_INITIAL_ERROR_MSG: "No fue posible revisar los eventos de los siguientes dispositivos, ya que no están recibiendo frames PROFIBUS:\n",
  S_MASTER_FAULT_INITIAL_ERROR_MSG: "No fue posible revisar el evento del dispositivo, ya que no está recibiendo frames PROFIBUS\n",

  MASTER_FAULT_SUGGESTION_1: "Cuando existan maestros en falla en la red se sugiere:",
  MASTER_FAULT_SUGGESTION_2: "Ocurre cuando el TS Monitor PROFIBUS PRO deja de leer la red. Sugerencia:",
  MASTER_FAULT_SUGGESTION_3: "Verifique si hubo una falla general en la red;",
  MASTER_FAULT_SUGGESTION_4: "Verifique si el TS Monitor fue aislado de la red;",
  MASTER_FAULT_SUGGESTION_5: "Verifique si el TS Monitor está correctamente conectado a la red PROFIBUS.",

  VOLTAGE_: "Tensión",
  // ---------------------------- FIBER LOWER LIMIT MAINTENANCE REQUIRED ----------------------------
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_ERROR_MSG: "No fue posible confirmar los eventos porque el enlace de fibra óptica aún presenta una falla en el nivel de tensión.",
  S_FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_INITIAL_ERROR_MSG: "No fue posible confirmar el evento porque el enlace de fibra óptica aún presenta una falla en el nivel de tensión.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_1: "Cuando se detecte un link de fibra óptica con falla en el nivel de tensión, se sugiere verificar visualmente:",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_2: "La alimentación del link de fibra;",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_3: "Verificar las conexiones de fibra y cobre;",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_4: "Verificar a condição das fibras óticas.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_5: "Se sugiere consultar el manual del fabricante del enlace de fibra para verificar el nivel de tensión adecuado.",

  // ---------------------------- FIBER LOWER LIMIT URGENT MAINTENANCE ----------------------------
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_ERROR_MSG: "No fue posible confirmar los eventos porque el enlace de fibra óptica aún presenta una falla grave en el nivel de tensión.",
  S_FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_INITIAL_ERROR_MSG: "No fue posible confirmar el evento porque el enlace de fibra óptica aún presenta una falla grave en el nivel de tensión.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_1: "Cuando se detecte un link de fibra óptica con una falla grave en el nivel de tensión, se sugiere verificar visualmente:",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_2: "La alimentación del link de fibra;",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_3: "Verificar las conexiones de fibra y cobre;",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_4: "Verificar a condição das fibras óticas.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_5: "Se sugiere consultar el manual del fabricante del enlace de fibra para verificar el nivel de tensión adecuado.",

  // ---------------------------- FIBER SIGNAL LOSS ----------------------------
  FIBER_SIGNAL_LOSS_ERROR_MSG: "No fue posible confirmar los eventos porque todavía se detecta una señal de falla por relé en el enlace de fibra óptica.",
  S_FIBER_SIGNAL_LOSS_INITIAL_ERROR_MSG: "No fue posible confirmar el evento porque todavía se detecta una señal de falla por relé en el enlace de fibra óptica.",

  FIBER_SIGNAL_LOSS_SUGGESTION_1: "Cuando se detecte una señal de falla por relé en el link de fibra óptica, se sugiere verificar visualmente:",

  FIBER_SIGNAL_LOSS_SUGGESTION_2: "La alimentación del link de fibra;",
  FIBER_SIGNAL_LOSS_SUGGESTION_3: "Verificar las conexiones de fibra y cobre;",
  FIBER_SIGNAL_LOSS_SUGGESTION_4: "Verificar la condición de las fibras ópticas.",

  // ---------------------------- EXPERT REPORT ----------------------------
  DEVICE_WITH_RETRIES_DOTS: "...........................................................................................",
  DEVICE_WITH_DIAGNOSTIC_DOTS: ".......................................................................................................",
  DEVICE_WITH_FAULT_DOTS: "....................................................................................................................",
  DEVICE_WITH_CONFIG_ERROR_DOTS: "........................................................................................",
  DEVICE_WITH_PARAM_ERROR_DOTS: "....................................................................................",
  DEVICE_MISSING_DOTS: ".......................................................................................................................",
  DEVICE_ONLINE_DOTS: "..........................................................................................................................",
  DEVICE_IS_CRITICAL_SLAVE_DOTS: "..............................................................................................",
  DEVICE_IS_MASTER_FAULT_DOTS: "...........................................................................................",
  DISCLAIMER_EXPERT_DOTS_1: "...................................................................................................................................",
  DISCLAIMER_EXPERT_DOTS_2: "......................................................................................................................................",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_DOTS: ".....................................",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_DOTS: "........................................",
  FIBER_SIGNAL_LOSS_DOTS: "............................................................................................",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_TITLE: ". - Link de fibra óptica – Falla en el nivel de tensión (Acción requerida)",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_TITLE: ". - Link de fibra óptica – Falla en el nivel de tensión (Acción urgente)",
  FIBER_SIGNAL_LOSS_PAGE_TITLE: ". - Link de fibra óptica – Falla por relé",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_DESCRIPTION: "TS Expert está indicando la presencia de link de fibra óptica con falla en el nivel de tensión.",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_DESCRIPTION: "TS Expert está indicando la presencia de link de fibra óptica con falla en el nivel de tensión.",
  FIBER_SIGNAL_LOSS_PAGE_DESCRIPTION: "TS Expert está indicando la presencia de link de fibra óptica con falla por relé",

  // ---------------------------- OPTIC FIBER ----------------------------
  OPTIC_FIBER: "Fibra óptica",
  RELAY_STATUS: "Estado del relé",
  RELAY_SIGNAL: "Señal del relé",
  MIN: "Mínimo",
  MAX: "Máximo",
  FAULT: "Falla",
  OK: "OK",
  MIN_ANALOG_VALUE: "Valor mínimo analógico",
  MIN_LIMIT_NOT_VALID: "El valor mínimo analógico no es válido",
  STATUS: "Estado",
  MAINTENANCE_URGENT: "Valor de mantenimiento urgente",
  MAINTENANCE_REQUIRED: "Valor de mantenimiento requerido",
  DIVERGENCE_MAINTENANCE_VALUE: "¡El valor de mantenimiento requerido no puede ser menor que el de mantenimiento urgente!",
  INVALID_VALUE: "Valor inválido",
  STR_LIMIT: "Hasta",
  CHANNEL_1: "Canal 1",
  CHANNEL_2: "Canal 2",
  CHANNEL_3: "Canal 3",
  CHANNEL_4: "Canal 4",
  CHANNEL_5: "Canal 5",
  ERROR_REASON: "\nMotivo: ",

  // -----------------------------------------------------------------------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------------------------------------------------------
  // ------------------------------------------------------ MEIO FÍSICO DP -------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------------------------------------------------------

  /// ---------------------------- Menu Bar ------------------------- 
  LIVE_LIST_MATRIX: "Matriz",
  OSCILLOSCOPE: "Osciloscopio",
  BAR_GRAPH: "Gráfico de barras",
  INFOS: "Agenda",
  CONFIG: "Configuraciones",

  // ---------------------------- Live List ----------------------------
  GOOD_STRING: "Bueno",
  ATTENTION_STRING: "Atención",
  BAD_STRING: "Malo",
  NO_SIGNAL_STRING: "Sin señal",
  UNKNOWN_STRING: "Desconocido",

  LIVE_LIST_INPUT_TEXT_PLACEHOLDER_DP: "Filtrar por dirección o señal",

  ADDRESSES: "Direcciones",
  AMPLITUDE: "Amplitud",
  AMPLITUDE_PRE: "Amplitud del preámbulo",
  MEAN_AMPLITUDE: "Amplitud media",
  MEAN_AMPLITUDE_N: "Amplitud\nmedia",
  MIN_AMPLITUDE: "Amplitud mínima",
  MIN_AMPLITUDE_N: "Amplitud\nmínima",
  MAX_AMPLITUDE: "Sobresinal",
  NOISE: "Ruido",
  SIGNAL: "Señal",
  RATIO: "Relación",
  NETWORK_TAG: "Tag del segmento",
  IS_IN_SEGMENT: "¿Pertenece al\nsegmento?",
  IS_IN_SEGMENT_1: "¿Pertenece al",
  IS_IN_SEGMENT_2: "segmento?",
  IS_IN_SEGMENT_DP: "Pertenece al Segmento: ",
  IS_IN_SEGMENT_QUESTION: "¿Pertenece al Segmento?",
  IS_IN_SEGMENT_LIVE_LIST_POPUP_1: "Indica si el dispositivo pertenece al mismo segmento que este TS Monitor PROFIBUS PRO.",
  IS_IN_SEGMENT_LIVE_LIST_POPUP_2: "Esta opción debe ajustarse manualmente para cada dispositivo en la pantalla de configuraciones.",

  MIN_AMPLITUDE_1: "Amplitud",
  MIN_AMPLITUDE_2: "mínima",

  MEAN_AMPLITUDE_1: "Amplitud",
  MEAN_AMPLITUDE_2: "media",

  RESPONSE_TIME_1: "Tiempo",
  RESPONSE_TIME_2: "respuesta",
  CURRENT: "actual",
  MINIMUM: "mínimo",
  MAXIMUM: "máximo",

  RESPONSE_TIME: "Tresp.\nactual",
  MIN_RESPONSE_TIME: "Tresp.\nmínimo",
  MAX_RESPONSE_TIME: "Tresp.\nmáximo",

  T_RESP: "T. Resp.",
  RESPONSE_TIME_POPUP: " es el tiempo de respuesta del dispositivo esclavo. Las variaciones pueden indicar problemas de hardware en los dispositivos.",
  MAX_RESPONSE_TIME_POPUP: "Mayor tiempo de respuesta registrado. Las variaciones pueden indicar problemas de hardware en los dispositivos.",
  MIN_RESPONSE_TIME_POPUP: "Menor tiempo de respuesta registrado. Las variaciones pueden indicar problemas de hardware en los dispositivos.",

  A: "A",
  B: "B",
  CHANNEL_A_PROBLEM: "Esta columna es un indicador de problemas en el canal A, cable verde, tales como:",
  CHANNEL_B_PROBLEM: "Esta columna es un indicador de problemas en el canal B, cable rojo, tales como:",
  AMPLITUDE_IDLE: "Tensión en idle ",

  NETWORK_DATA: "Datos de la red",

  MODAL_TITLE: "Formas de onda características",

  TURNED_ON: "Encendida",
  TURNED_OFF: "Apagada",

  ANALYSIS_ERROR: "Ocurrió un error al cambiar el estado del análisis",

  ANALYSIS: "Análisis",
  ANALYZER: "TS Scope DP ",

  DETECTED_PROBLEMS: "Problemas detectados:",
  INIT_PICO_NOT_FOUND: "TS Monitor PROFIBUS PRO no encontrado, por favor conéctelo a la computadora.",
  INVERTED_AB: "Los cables A y B están invertidos.",
  MONGO_OFF: "Error en la base de datos, cierre el programa y ábralo nuevamente. Si el error persiste, haga clic en el botón de abajo.",
  PICO_NOT_FOUND: "El TS Monitor PROFIBUS PRO está desconectado. Después de reconectarlo, es necesario reiniciar el programa.",
  MONGO_REPAIR_SUCCESS: "¡Error reparado con éxito! Por favor cierre el programa y ábralo nuevamente para que los cambios tengan efecto.",
  MONGO_REPAIR_ERROR: "No fue posible solucionar el problema. Por favor comuníquese para recibir soporte.",
  INIT_PICO_NOT_FOUND_PLAY: "Error al iniciar TS Monitor PROFIBUS PRO. Por favor desconéctelo de su computadora, vuelva a conectarlo y reinicie el programa. Si el error persiste, reinicie la computadora e intente nuevamente.",

  REPAIR: "Reparar",
  LOADING_ANALYZER: "Iniciando TS Monitor PROFIBUS PRO, por favor espere.",

  NO_DP_ACTIVE_NETWORK: "TS Monitor PROFIBUS PRO no encontró una red activa, asegúrese de que esté conectado correctamente a una red PROFIBUS DP e intente nuevamente.",

  INVALID_SERIAL: "El número de serie no corresponde a este TS Monitor PROFIBUS PRO. Por favor reinstale el programa con un número de serie válido.",
  INVERTED_AB_POPUP: "Los cables A y B están invertidos.\nPor favor invierta nuevamente los cables y presione Play otra vez.",

  MONGO_OFF_POPUP: "Error al inicializar la base de datos, haga clic en el botón de abajo para reparar el problema.",

  MEAN_AMPLITUDE_DESC: "Valor de amplitud medido entre el promedio de los puntos en nivel lógico alto y el promedio de los puntos en nivel lógico bajo, como ilustra la figura abajo.",
  MEAN_AMPLITUDE_DESC_2: "Una amplitud media alta es un indicio de falta de terminadores. Cuando es baja, indica: resistencia en las conexiones; exceso de terminadores; cables prensados; cables aplastados o doblados, etc.",
  AMPLITUDE_MIN_DESC: "Valor de amplitud entre el punto más bajo de la forma de onda en nivel lógico alto y el punto más alto en nivel lógico bajo, como ilustra la figura abajo.",
  AMPLITUDE_MIN_DESC_2: "Una gran diferencia entre la amplitud media y la mínima indica: reflexión (terminadores); cable largo; ruido; humedad en el bus, etc.",
  OVERSHOOTING_DESC: "Valor de amplitud entre el valor medio de la forma de onda en nivel lógico alto y el punto más alto en nivel lógico alto, como ilustra la figura abajo.",
  OVERSHOOTING_DESC_2: "Indica: falta de terminadores; conexiones en medio del bus; derivaciones, etc.",
  RATIO_DESC_1: "Relación entre los valores de amplitud mínima y amplitud media, con el objetivo de hacer evidente la degradación de la señal.",
  RATIO_DESC_2: "Cuanto más próximo a 1, mejor; y cuanto más próximo a 0 (cero), peor la calidad de la señal.",
  RATIO_FOMULA: "Relación = Amp. mínima / Amp. media",

  IDLE_DESCRIPTION: " Período en el que la red está ociosa, es decir, es el período entre una pregunta del maestro y la respuesta del esclavo, o entre paquetes del maestro para sí mismo. La tensión ideal del idle es 1V; valores diferentes indican problemas en la red.",
  IDLE_DESCRIPTION_2: "Si la tensión en idle es menor que 0,6 V, el valor será resaltado en naranja.",

  MONITOR_IP_NOT_FOUND: "IP del monitor no encontrado",

  CHANNEL_DESCRIPTION_1: "Cortocircuito",
  CHANNEL_DESCRIPTION_2: "Borne flojo",
  CHANNEL_DESCRIPTION_3: "Cable roto",
  CHANNEL_DESCRIPTION_4: "U otro problema que dañe la señal de comunicación.",

  SIGNAL_QUALITY: "Calidad de la señal",
  SIGNAL_QUALITY_DESCRIPTION_1: "En la columna “Señal” siempre se considera el peor caso para la amplitud media y mínima.",

  GOOD: "Bueno",
  GOOD_DESCRIPTION_1: "• Amplitud media de 4 a 7 V",
  GOOD_DESCRIPTION_2: ". Señal con buena amplitud!",

  ATTENTION: "Atención - Acción preventiva",
  ATTENTION_DESCRIPTION_1: "• Amplitud media de 7 a 8 V",
  ATTENTION_DESCRIPTION_2: ". Puede indicar falta de terminadores.",
  ATTENTION_DESCRIPTION_3: "• Amplitud media de 3 a 4 V",
  ATTENTION_DESCRIPTION_4: ". Puede indicar resistencia en el bus, demasiados terminadores, problemas de conexión, bornes flojos, problema en esclavo, etc.",

  BAD: "Malo - Acción correctiva",

  BAD_DESCRIPTION_1: "• Amplitud media menor que 3 V",
  BAD_DESCRIPTION_2: " o mayor que 8 V",
  BAD_DESCRIPTION_3: ", puede causar pérdida de paquetes PROFIBUS.",
  BAD_DESCRIPTION_4: "• Amplitud mínima menor que 3 V",
  BAD_DESCRIPTION_5: " puede causar pérdida de paquetes PROFIBUS.",

  LIGHT_TONES: "Tonos claros",
  LIGHT_TONES_DESCRIPTION: "• TS Monitor PROFIBUS PRO no está encontrando respuesta del esclavo, por lo tanto el software mantiene las mediciones de la última captura y utiliza tonos claros para indicar que no está actualizando los datos.",

  // ---------------------------- Oscilloscope ----------------------------
  GRAPH: "Gráfico",
  A_AND_B: "A y B",
  B_A: "B - A",
  WAVE_FORM: "Forma de onda",
  AMPLITUDE_A: "Amplitud A",
  AMPLITUDE_B: "Amplitud B",
  ADDRESS_DP: "Dirección: ",
  WAVE_A: "Señal A",
  WAVE_B: "Señal B",
  WAVE_B_A: "Señal B - A",
  WAVE_PA: "Señal PA",

  NANOSSECOND: "ns",
  MICROSSECOND: " µs",
  MILLISSECOND: " ms",
  SECOND: "s",

  TIME_NS: "Tiempo (ns)",
  TIME_US: "Tiempo (μs)",
  TIME_MS: "Tiempo (ms)",
  TIME_S: "Tiempo (s)",

  AMPLITUDE_PLACEHOLDER: "0.0 V",
  TIME_INTERVAL_PLACEHOLDER: "0.0",
  VOLTAGE: " V",
  VOLTAGE_PEAK_TO_PEAK: " V",
  CURSORS: "Cursores",
  CONTROLS: "Controles ",
  TIME_INTERVAL: " tiempo",
  CONTROLS_POPUP_TEXT: "Después de presionar PLAY, la forma de onda se actualiza aproximadamente cada 200 milisegundos.",
  CONTROLS_POPUP_TEXT_2: "Para habilitar los controles es necesario seleccionar la visualización manual y elegir un dispositivo.",

  SIZE: "Tamaño ",
  VISUALIZATION: "Visualización",
  AUTOMATIC: "Automática",
  MANUAL: "Manual",

  STD_WAVE_FORM: "Forma de onda estándar",
  LONG_CABLE_WAVE_FORM: "Forma de onda típica de cable largo",
  EXCESS_TERMINATIOR_WAVE_FORM: "Forma de onda típica de exceso de terminador",
  NO_SLAVE_WAVE_FORM: "Forma de onda típica de ausencia de esclavo (dispositivos desconectados)",
  REFLECTION_WAVE_FORM: "Forma de onda típica con reflexión",
  NO_TERMINATOR_WAVE_FORM: "Forma de onda típica de falta de terminador",
  FOR_MORE_INFO_DP: "Para información adicional, consulte a Toledo & Souza o las directrices de PROFIBUS International. Cabe destacar que los eventos mostrados pueden ocurrir en conjunto, lo que cambia los patrones mostrados.",
  FEW_TERMINATOR_WAVE_FORM: "Forma de onda típica de poco terminador",

  WAVE_SIZE_DESC_1: "TS Monitor PROFIBUS PRO ya muestrea el frame de dos modos con solo 1 Byte o con 3 Bytes, de modo que aquí podemos visualizar con un mayor zoom en 1 Byte o un menor zoom en 3 Bytes.",
  WAVE_SIZE_DESC_2: "Existe una excepción: el frame “E5” – short acknowledgement – siempre tiene solo 1 Byte.",
  WAVE_SIZE_DESC_3: "A continuación, un ejemplo en un frame con más de 1 y 3 Bytes.",

  TS_SCOPE_NOT_FINDING_ANSWER: "TS Monitor PROFIBUS PRO no está encontrando respuesta del esclavo, por lo tanto los datos están desactualizados. La forma de onda de abajo es la última capturada por el sistema.",

  TIME_DP: "Tiempo: ",
  PS_1: "Obs 1:",
  PS_2: "Obs 2:",
  PS_3: "Obs 3:",

  // ---------------------------- Bar Graph ----------------------------
  ORDER_BY: "Ordenar por",
  AMPLITUDE_ASC: "Amplitud creciente",
  AMPLITUDE_DESC: "Amplitud decreciente",
  ADDRESS_ASC: "Dirección creciente",
  VOLTAGE_V: "Tensión (V)",
  VOLTAGE_V_PEAK_TO_PEAK: "Tensión (V)",
  VOLTAGE_MV: "Tensión (mV)",
  VOLTAGE_MV_PEAK_TO_PEAK: "Tensión (mV)",
  ORDER: "Ordenación",
  REFRESH_DATA: "Actualizar datos",
  LOADING: "Cargando",

  // ---------------------------- Log ----------------------------
  INSERT_VALID_TYPE: "Por favor ingrese un tipo de evento válido.",
  LOG_INPUT_TEXT_PLACEHOLDER_DP: "Filtrar por tipo de evento",
  TYPE: "Tipo",

  TERMINATION_OFF_LOG_DESCRIPTION: "TS Expert detectó una posible falta de terminador en la red.",
  NO_TERMINATION_LOG_DESCRIPTION: "TS Expert detectó una posible ausencia de terminador en el segmento al que está conectado.",
  NO_POWER_SUPPLY_LOG_DESCRIPTION: "TS Expert detectó una posible falta de alimentación en el terminador.",
  HIGH_RESISTANCE_LOG_DESCRIPTION: "TS Expert detectó un posible exceso de terminadores o alta resistencia en el bus PROFIBUS.",
  A_NOT_OK_LOG_DESCRIPTION: "TS Expert detectó un posible cortocircuito entre el conductor A y la malla de blindaje, o la masa aterrada de un panel o esclavo.",
  B_NOT_OK_LOG_DESCRIPTION: "TS Expert detectó un posible cortocircuito entre el conductor B y la malla de blindaje, o la masa aterrada de un panel o esclavo.",
  LONG_CABLE_LOG_DESCRIPTION: "TS Expert detectó una posible condición de bus con longitud mayor a la permitida.",
  NOISE_LOG_DESCRIPTION: "TS Expert detectó una posible condición de ruido en la red PROFIBUS.",
  REFLECTION_LOG_DESCRIPTION: "TS Expert detectó la presencia de reflexión en la forma de onda.",
  DEFORMED_WAVE_LOG_DESCRIPTION: "TS Expert detectó la presencia de señal fuera del patrón.",
  DUPLICATE_LOG_DESCRIPTION: "TS Expert detectó una posible presencia de dos esclavos con la misma dirección en la red.",
  EVENT_CHECKED_SUCCESS: "El evento fue revisado con éxito.",
  OPTIC_FIBER_EVENT_CHECKED_SUCCESS: "El evento se limpió con éxito.",

  // ---------------------------- Report ----------------------------
  REPORT_EXPORT_NAME_DP: "Informe TS Monitor PROFIBUS PRO - Capa Física DP",
  HEADER_TEXT_DP: "Informe de datos - TS Monitor PROFIBUS PRO - Capa Física DP",

  ANALYZER_VERSION_STRING: "- Versión del monitor:",
  ANALYZER_VERSION: "4.0.0",

  PROTOCOL: "- Protocolo:",
  PROTOCOL_TYPE: "PROFIBUS DP",

  ANALYSIS_INIT: "- Inicio del monitoreo:",
  REPORT_GENERATION: "- Generación del informe:",
  ANALYSIS_DURATION: "- Duración del monitoreo hasta la generación del informe: ",

  REPORT_TYPE: "Tipo de Informe",

  CONFORM: "Conforme",
  CONFORM_W_RESTRICTION: "Conforme con restricciones",
  NON_CONFORM: "No conforme",

  A_LIVE_LIST_PAGE_TITLE: "1. - Live List",
  A_OSCILLOSCOPE_PAGE_TITLE: "2. - Osciloscopio",
  A_BAR_GRAPH_PAGE_TITLE: "3. - Gráfico de barras",
  A_LOG_PAGE_TITLE: "4. - Log de eventos",

  B_LIVE_LIST_PAGE_TITLE: "2.1. - Live List",
  B_OSCILLOSCOPE_PAGE_TITLE: "2.2. - Osciloscopio",
  B_BAR_GRAPH_PAGE_TITLE: "2.3. - Gráfico de barras",
  B_LOG_PAGE_TITLE: "2.4. - Log de eventos",

  ANALYSIS_INFO: "Información del monitoreo",
  GENERATED_BY: "- Generado por TS Monitor PROFIBUS PRO",
  HARDWARE_VERSION: "- Versión de hardware:",
  SOFTWARE_VERSION: "- Versión de software:",
  DATE_TIME: "- Fecha y hora:",
  BAUD_RATE: "- Baud rate:",
  CYCLE_TIME: "- Tiempo de ciclo:",
  NUM_MASTERS: "- Maestros:",
  NUM_SLAVES: "- Esclavos:",
  AMPLITUDE_IDLE_1: "- Tensión en idle:",
  SEGMENT_TAG: "- Tag del segmento: ",

  LIVE_LIST_DOTS_DP: "........................................................................................................................................",
  BAR_DOTS_DP: ".........................................................................................................................",
  OSC_DOTS_DP: "................................................................................................................................",
  LOG_DOTS_DP: "................................................................................................................................................",
  DISCLAIMER_DOTS_DP: "....................................................................................................................................",

  SELECT_REPORT_TYPE: "Por favor seleccione un tipo de informe",

  MASTER_DP: "Maestro: ",
  SLAVE_DP: "Esclavo: ",
  SIGNAL_DP: "Señal: ",
  AMPLITUDE_DP: "Amplitud: ",
  AMPLITUDE_PRE_DP: "Amplitud del preámbulo: ",
  AMPLITUDE_MIN_DP: "Amplitud mínima: ",
  OVERSHOOTING_DP: "Sobresinal: ",
  AMPLITUDE_MAX_DP: "Amplitud máxima: ",

  GENERAL_INFORMATION: "Información general",

  CAPTURE_TIME: "Hora de la captura",

  PROJECT_NAME_LABEL: "Nombre del proyecto",
  NETWORK_LABEL: "Nombre de la red",
  LOCATION_LABEL: "Ubicación",
  COMPANY_NAME_LABEL: "Nombre de la empresa",
  ACCOUNTABLE_NAME_LABEL: "Nombre del responsable",
  CITY_LABEL: "Ciudad",
  TEL_LABEL: "Teléfono",
  CLIENT_LOGO_LABEL: "Logo del cliente",
  EMAIL_LABEL: "Correo electrónico",
  EXECUTING_COMPANY_LOGO_LABEL: "Logo de la empresa ejecutora",
  FINISHING: "Finalizando...",
  SAVE_REPORT: "Guardar informe",
  SLAVE_NOT_FOUND_SHOWING_LAST_WAVEFORM: "No se pudo encontrar el esclavo en la red, mostrando la última forma de onda capturada.",
  REPORT_MN_PB_PRO_FULL: "Informe - TS Monitor PROFIBUS PRO - Completo",
  REPORT_MN_PB_PRO_PROTOCOL: "Informe - TS Monitor PROFIBUS PRO - Protocolo",
  REPORT_MN_PB_PRO_PHYS_MEDIUM: "Informe - TS Monitor PROFIBUS PRO - Capa Física DP",
  MASTER: "Maestro ",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN: "LOGIN",
  ENTER: "Entrar",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LOG_DESCRIPTION: "El TS Expert detectó una posible falla en el nivel de tensión (Acción requerida).",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LOG_DESCRIPTION: "El TS Expert detectó una posible falla en el nivel de tensión (Acción urgente).",
  FIBER_SIGNAL_LOSS_LOG_DESCRIPTION: "El TS Expert detectó una posible falla por relé.",

  LOGOUT: "Cerrar sesión",
  MASK: "Máscara",
  TAGS: "Tags",
  INTERFACE_CONFIG: "Configuraciones de Interfaz",
  ARE_YOU_SURE_ALTER_CONFIG: "¿Está seguro de que desea cambiar las configuraciones Ethernet del TS Monitor PROFIBUS PRO?",

  GPG_FILE_EXTENSION: ".gpg",
  SEND_FILE_SUCCESS: "El archivo fue enviado con éxito.",
  SEND_FILE_SUCCESS_WARNING: "No olvide verificar si la placa de red de su computadora está en la misma subred de la IP: ",
  SEND_CONFIG_SUCCESS: "Las configuraciones fueron enviadas con éxito.",
  START_MESSAGE_SUCCESS: "El monitor se iniciará en 15 segundos.",
  START_MESSAGE_FAILURE: "Ocurrió un error al iniciar el monitor.",
  STOP_MESSAGE_SUCCESS: "El monitor se detendrá en 15 segundos.",
  STOP_MESSAGE_FAILURE: "Ocurrió un error al detener el monitor.",
  RESET_TRAFFIC_SUCCESS: "Los valores se pondrán en cero en el próximo barrido.",
  RESET_TRAFFIC_FAILURE: "Ocurrió un error al poner en cero los incrementos de error.",
  RESET_DEVICES_SUCCESS: "Los datos de los dispositivos fueron limpiados con éxito.",
  RESET_DEVICES_FAILURE: "Ocurrió un error al limpiar los datos de los dispositivos.",
  RESET_RETRIES_SUCCESS: "Los reintentos fueron limpiados con éxito.",
  RESET_RETRIES_FAILURE: "Ocurrió un error al limpiar los reintentos.",

  TAG_TOO_LONG: "\n- El tamaño de la tag no puede superar los 30 caracteres",

  SYSTEM: "Sistema",
  RESTART: "Reiniciar",

  SCOPE_DP_IP_WAS_CHANGED_SUCCESSFULLY: "• La IP del TS Monitor PROFIBUS PRO fue modificada con éxito.",
  NOTE_WAS_CHANGED_SUCCESSFULLY: "• La observación fue modificada con éxito.",

  NOTE: "Observación",
  MONITOR_IP: "IP del Monitor",

  IN_SEGMENT_DEVICES: "Dispositivos del segmento",
  UPDATING_DATA: "Actualizando información, espere",
  IN_SEGMENT_FORM_INPUT_PLACEHOLDER: "Filtrar dispositivos por dirección",

  IS_IN_SEGMENT_POPUP_DESCRIPTION_1: "Lista de dispositivos que pertenecen al mismo segmento que el TS Monitor PROFIBUS PRO.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_2: "Si el dispositivo aparece desmarcado en esta lista, significa que no pertenece al mismo segmento que el TS Monitor PROFIBUS PRO.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_3: "Si no pertenece al mismo segmento, la forma de onda vista en el osciloscopio puede no corresponder a la forma de onda real del dispositivo.",

  CONFIRM_ALTER_SEGMENT_DEVICES: "¿Está seguro de que desea realizar los cambios en la lista de dispositivos pertenecientes al segmento?",

  ALTER_IS_IN_SEGMENT_LIST_FAILURE: "Ocurrió un error al cambiar la lista de dispositivos del segmento.",
  ALTER_IS_IN_SEGMENT_LIST_SUCCESS: "¡La lista de dispositivos del segmento fue cambiada con éxito!",

  TS_EXPERT_CONFIG_POPUP: "Permite habilitar / deshabilitar las no conformidades que serán informadas por la herramienta.",

  NTP_INFO_TURNED_ON_SUCCESS: "El servidor NTP fue encendido con éxito.",
  TURN_ON_DATE: "\nLa hora del servidor fue actualizada a: ",

  MONITOR_WILL_BE_RESTARTED: "\nTS Monitor PROFIBUS PRO será reiniciado ahora,",

  NTP_INFO_TURNED_OFF_SUCCESS: "El servidor NTP fue apagado con éxito.",
  TURN_OFF_DATE: "\nHora de apagado: ",

  TAG_CONFIG_DP: "Tag del segmento",

  INVALID_MONITOR_IP: "La IP del monitor ingresada es inválida.",
  MONITOR_IP_WAS_CHANGED_SUCCESSFULLY: "La IP del monitor fue modificada con éxito.",
  MONITOR_IP_CHANGE_FAILURE: "Ocurrió un error al modificar la IP del monitor.",

  INVALID_HOSTNAME: "El hostname no puede estar en blanco, ni contener espacios o caracteres especiales.",

  CHANGE_IDLE_SIZE: "Cambiar tamaño del idle",
  CHANGE_IDLE_SIZE_QUESTION_1: "Cambiar el tamaño del idle reiniciará los procedimientos internos del TS Monitor PROFIBUS PRO. Este procedimiento puede tardar hasta 3 minutos.",
  CHANGE_IDLE_SIZE_QUESTION_2: "Al hacer clic en sí, espere en la pantalla hasta que finalice. ¿Está seguro de que desea continuar?",

  CHANGE_PACKET_SIZE: "Cambiar tamaño del paquete",
  CHANGE_PACKET_SIZE_QUESTION_1: "Cambiar el tamaño del paquete reiniciará los procedimientos internos del TS Monitor PROFIBUS PRO. Este procedimiento puede tardar hasta 3 minutos.",
  CHANGE_PACKET_SIZE_QUESTION_2: "Al hacer clic en sí, espere en la pantalla hasta que finalice. ¿Está seguro de que desea continuar?",

  // ---------------------------- TS EXPERT CONFIG ---------------------------- 
  TERMINATION_OFF_LIST_HEADER: "Terminador en posición OFF",
  TERMINATION_OFF_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará una posible falta de terminador en la red.",

  NO_TERMINATION_LIST_HEADER: "Segmento sin terminación",
  NO_TERMINATION_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará una posible ausencia de terminador en el segmento al que está conectado.",

  NO_POWER_SUPPLY_LIST_HEADER: "Terminador sin alimentación",
  NO_POWER_SUPPLY_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario una posible falta de alimentación en el terminador.",

  HIGH_RESISTANCE_LIST_HEADER: "Señal atenuada",
  HIGH_RESISTANCE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario un posible exceso de terminadores o alta resistencia en el bus PROFIBUS.",

  A_NOT_OK_LIST_HEADER: "Corto entre el conductor A y la malla",
  A_NOT_OK_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario un posible cortocircuito entre el conductor A y la malla de blindaje o la masa aterrada de un panel o esclavo.",

  B_NOT_OK_LIST_HEADER: "Corto entre el conductor B y la malla",
  B_NOT_OK_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario un posible cortocircuito entre el conductor B y la malla de blindaje o la masa aterrada de un panel o esclavo.",

  LONG_CABLE_LIST_HEADER: "Cable largo",
  LONG_CABLE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario una posible condición de bus con longitud mayor a la permitida.",

  NOISE_LIST_HEADER: "Ruido o bajo aislamiento (fuga a tierra)",
  NOISE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario una posible condición de ruido en la red PROFIBUS.",

  REFLECTION_LIST_HEADER: "Reflexión en la forma de onda",
  REFLECTION_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará la presencia de reflexión en la forma de onda.",

  DEFORMED_WAVE_LIST_HEADER: "Señal deformada",
  DEFORMED_WAVE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará la presencia de señal fuera del patrón.",

  DUPLICATE_ADDRESS_LIST_HEADER: "Dirección duplicada",
  DUPLICATE_ADDRESS_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará una posible presencia de dos esclavos con la misma dirección en la red.",

  // ---------------------------- TS EXPERT ----------------------------

  QUANTITY_DP: "Cantidad: ",
  INCREMENTS: "Incrementos",

  PORT_IS_STILL_INACTIVE: "El puerto aún está inactivo",
  MARK_PROBLEM_AS_SOLVED: "¿Está seguro de que desea marcar el evento como revisado?",

  ALL_EVENTS_CHECKED: "Todos los eventos fueron verificados con éxito.",

  DEVICES: "Dispositivos",

  // ---------------------------- TERMINADOR OFF ----------------------------
  TERMINATION_OFF_SUGGESTION_1: "Cuando el terminador esté en la posición OFF se sugiere:",
  TERMINATION_OFF_SUGGESTION_2: "Verificar visualmente:",
  TERMINATION_OFF_SUGGESTION_3: "Si los terminadores en ambos extremos del segmento están en la posición \"on\";",
  TERMINATION_OFF_SUGGESTION_4: "Si no se utilizan conectores PROFIBUS, verificar si existe terminador activo en ambos extremos;",
  TERMINATION_OFF_SUGGESTION_5: "Si no existe terminador en uno de los extremos, es necesario realizar la instalación.",
  TERMINATION_OFF_SUGGESTION_6: "Se recomienda esperar una parada o coordinar con producción antes de encender el terminador apagado o instalar un terminador activo, ya que este cambio puede hacer caer la red.",

  // ---------------------------- SEM TERMINADOR ----------------------------
  NO_TERMINATION_SUGGESTION_1: "Cuando el segmento esté sin terminación se sugiere:",
  NO_TERMINATION_SUGGESTION_2: "Verificar visualmente si:",

  NO_TERMINATION_SUGGESTION_3: "Si los terminadores en ambos extremos del segmento están en la posición \"on\";",
  NO_TERMINATION_SUGGESTION_4: "Si no se utilizan conectores PROFIBUS, verificar si existe terminador activo en ambos extremos;",
  NO_TERMINATION_SUGGESTION_5: "Si no existe terminador en uno de los extremos, es necesario realizar la instalación.",

  NO_TERMINATION_SUGGESTION_6: "Se recomienda esperar una parada o coordinar con producción antes de encender el terminador apagado o instalar un terminador activo, ya que este cambio puede hacer caer la red.",

  // ---------------------------- NO POWER SUPPLY ----------------------------
  NO_POWER_SUPPLY_SUGGESTION_1: "Cuando el terminador esté sin alimentación se sugiere:",
  NO_POWER_SUPPLY_SUGGESTION_2: "Verificar la alimentación de los terminadores activos (cuando el dispositivo esté instalado) y verificar la alimentación para terminadores en el esclavo o maestro en los pines del conector DB9, siendo:",
  NO_POWER_SUPPLY_SUGGESTION_3: "En el caso de terminador activo, basta con alimentarlo; pero en el caso del conector DB9 es necesario verificar si el problema está en el conector o en la alimentación proveniente del esclavo o maestro.",
  NO_POWER_SUPPLY_SUGGESTION_4: "Se recomienda realizar estos procedimientos con la producción detenida, ya que este cambio puede hacer caer la red.",

  // ---------------------------- HIGH RESISTANCE ----------------------------
  HIGH_RESISTANCE_SUGGESTION_1: "Cuando la señal esté atenuada se sugiere:",
  HIGH_RESISTANCE_SUGGESTION_2: "Verificar:",

  HIGH_RESISTANCE_SUGGESTION_3: "Si algún equipo del segmento tiene el terminador interno activado;",
  HIGH_RESISTANCE_SUGGESTION_4: "Si no hay ningún equipo con terminador interno activado, verificar la electrónica de los esclavos, aislándolos individualmente del bus;",
  HIGH_RESISTANCE_SUGGESTION_5: "Verificar si existen bornes flojos en las conexiones por borne o conectores a borne;",
  HIGH_RESISTANCE_SUGGESTION_6: "Verificar mal contacto en conectores del tipo “vampiro”;",
  HIGH_RESISTANCE_SUGGESTION_7: "Verificar si existen cables aplastados, lo que aumentaría la resistencia del cable.",

  HIGH_RESISTANCE_SUGGESTION_8: "Esta verificación puede hacerse con la red en funcionamiento; sin embargo, para cualquier intervención se recomienda esperar una parada, pues estos cambios pueden hacer caer la red.",

  // ---------------------------- A NOT OK ----------------------------
  A_NOT_OK_SUGGESTION_1: "Cuando haya corto entre el conductor A y la malla se sugiere:",
  A_NOT_OK_SUGGESTION_2: "Realizar una inspección visual:",
  A_NOT_OK_SUGGESTION_3: "Interna de los conectores, verificando si hay corto entre el conductor A y la malla;",
  A_NOT_OK_SUGGESTION_4: "A lo largo de todo el segmento, verificando si hay algún tramo del cable dañado, prensado en bandeja portacables, cortado en la salida de tubería o aplastado por cajón de CCM, etc.",

  // ---------------------------- B NOT OK ----------------------------
  B_NOT_OK_SUGGESTION_1: "Cuando haya corto entre el conductor B y la malla se sugiere:",
  B_NOT_OK_SUGGESTION_2: "Realizar una inspección visual:",
  B_NOT_OK_SUGGESTION_3: "Interna de los conectores, verificando si hay corto entre el conductor B y la malla;",
  B_NOT_OK_SUGGESTION_4: "A lo largo de todo el segmento, verificando si hay algún tramo del cable dañado, prensado en bandeja portacables, cortado en la salida de tubería o aplastado por cajón de CCM, etc.",

  // ---------------------------- LONG CABLE ----------------------------
  LONG_CABLE_SUGGESTION_1: "Cuando el cable sea demasiado largo se sugiere:",
  LONG_CABLE_SUGGESTION_2: "Realizar una inspección visual del segmento y verificar si el bus es demasiado largo para el baud rate (velocidad de comunicación), según la tabla de abajo.",
  LONG_CABLE_SUGGESTION_3: "Si el segmento es mayor a lo permitido, se sugiere insertar un repetidor o enlace de fibra óptica, dividiendo el segmento.",

  BAUD_RATE_: "Baud rate",
  LENGTH: "Longitud",
  NINE_SIX_KBITS: "9,6 kbit/s",
  NINETEEN_KBITS: "19,2 kbit/s",
  FORTY_FIVE_KBITS: "45,45 kbit/s",
  NINETY_THREE_KBITS: "93,75 kbit/s",
  HUN_EIGHTY_SEVEN_KBITS: "187,5 kbit/s",
  FIVE_HUNDRED_KBITS: "500,0 kbit/s",
  ONE_FIVE_KBITS: "1,5 Mbit/s",
  THREE_MBPS: "3,0 Mbit/s",
  SIX_MBPS: "6,0 Mbit/s",
  TWELVE_MBPS: "12,0 Mbit/s",

  // ---------------------------- NOISE ----------------------------
  NOISE_SUGGESTION_1: "Cuando haya ruido o bajo aislamiento (fuga a tierra) se sugiere:",
  NOISE_SUGGESTION_2: "3 consejos tienden a ayudar a solucionar este problema:",
  NOISE_SUGGESTION_3: "Para atenuar el ruido es necesario verificar si todos los esclavos de la red están debidamente aterrados;",
  NOISE_SUGGESTION_4: "Corriente medida en la pantalla con la pantalla conectada a tierra en ambos extremos:",
  NOISE_SUGGESTION_5: "Verificar el aislamiento de las interfaces de los esclavos; un modo simple es ir desconectando uno a uno los esclavos del segmento y verificar en TS Monitor si el problema persiste, es decir, si en la Live List las señales se estabilizan en BUENO).",
  NOISE_SUGGESTION_6: "Si el problema persiste después de estos consejos, recomendamos buscar un especialista en redes PROFIBUS.",

  NOISE_SUGGESTION_TABLE_HEADER_1: "Corriente",
  NOISE_SUGGESTION_TABLE_HEADER_2: "Acción",

  NOISE_SUGGESTION_TABLE_11: "5 mA",
  NOISE_SUGGESTION_TABLE_12: "Valor muy bueno, especialmente recomendable en plantas industriales.",
  NOISE_SUGGESTION_TABLE_21: "30 mA",
  NOISE_SUGGESTION_TABLE_22: "No se requiere ninguna acción fuera de las áreas peligrosas.",
  NOISE_SUGGESTION_TABLE_31: "30 mA a 100 mA",
  NOISE_SUGGESTION_TABLE_321: "Verificar la causa y reducir el valor por debajo de ",
  NOISE_SUGGESTION_TABLE_322: "30 mA",
  NOISE_SUGGESTION_TABLE_323: ", si es posible.",
  NOISE_SUGGESTION_TABLE_41: "100 mA",
  NOISE_SUGGESTION_TABLE_42: "Eliminar la fuente de interferencia, mejorar/interconectar la red de equipotencialización, reducir las corrientes parásitas y, si es necesario, aumentar la distancia entre las líneas de potencia y las líneas de bus.",
  NECESSARY_ACTION: "Acción necesaria: ",
  
  // ---------------------------- REFLECTION ----------------------------
  REFLECTION_SUGGESTION_1: "Cuando haya reflexión en la forma de onda se sugiere:",
  REFLECTION_SUGGESTION_2: "Este evento está casi siempre asociado a la falta de terminación en la red, por lo tanto se debe verificar visualmente:",

  REFLECTION_SUGGESTION_3: "Si los terminadores en ambos extremos del segmento están en la posición “on”;",
  REFLECTION_SUGGESTION_4: "Si no se utilizan conectores PROFIBUS, verificar si existe terminador activo en ambos extremos;",
  REFLECTION_SUGGESTION_5: "Si no existe terminador en uno de los extremos, es necesario realizar la instalación.",

  REFLECTION_SUGGESTION_6: "Sin embargo, la reflexión también puede ser resultado de empalmes en el cable, uso de bornes inadecuados, cables aplastados, cambio de tipo de cable, uso de empalme con M12 o cualquier otra alteración en la capa física de comunicación.",
  REFLECTION_SUGGESTION_7: "En estos casos, es necesaria una inspección visual detallada en el segmento de red indicado.",

  // ---------------------------- DEFORMED WAVE ----------------------------
  DEFORMED_WAVE_SUGGESTION_1: "Cuando se detecte una señal deformada se sugiere:",
  DEFORMED_WAVE_SUGGESTION_2: "Verificar el bus en busca de:",
  DEFORMED_WAVE_SUGGESTION_3: "Esclavo con dirección repetida;",
  DEFORMED_WAVE_SUGGESTION_4: "Cables doblados;",
  DEFORMED_WAVE_SUGGESTION_5: "Bornes flojos;",
  DEFORMED_WAVE_SUGGESTION_6: "Conectores mal montados;",
  DEFORMED_WAVE_SUGGESTION_7: "Cables aplastados;",
  DEFORMED_WAVE_SUGGESTION_8: "Cables cortados o dañados;",
  DEFORMED_WAVE_SUGGESTION_9: "Alimentación incorrecta de terminadores activos.",

  // ---------------------------- DUPLICATE ADDRESS ----------------------------
  DUPLICATE_IP_SUGGESTION_1: "Cuando una dirección esté duplicada se sugiere:",
  DUPLICATE_IP_SUGGESTION_2: "Realizar una inspección visual de la red y verificar si existen dos o más esclavos con la misma dirección. Si existe, verificar cuál es el esclavo correcto y direccionar el otro con un nodo libre.",

  // ---------------------------- EXPERT REPORT ----------------------------
  SAVE_ACTIONS_LIST: "Guardar lista de acciones",
  ACTIONS_LIST_FILENAME_PART: "Lista de acciones - TS Monitor PROFIBUS PRO",

  TERMINATION_OFF_PAGE_TITLE: ". - Terminador en posición OFF",
  NO_TERMINATION_PAGE_TITLE: ". - Segmento sin terminación",
  NO_POWER_SUPPLY_TERMINATION_PAGE_TITLE: ". - Terminador sin alimentación",
  HIGH_RESISTANCE_PAGE_TITLE: ". - Señal atenuada",
  A_NOT_OK_PAGE_TITLE: ". - Corto entre el conductor A y la malla",
  B_NOT_OK_PAGE_TITLE: ". - Corto entre el conductor B y la malla",
  LONG_CABLE_PAGE_TITLE: ". - Cable largo",
  NOISE_PAGE_TITLE: ". - Ruido o bajo aislamiento (fuga a tierra)",
  REFLECTION_PAGE_TITLE: ". - Reflexión en la forma de onda",
  DEFORMED_WAVE_PAGE_TITLE: ". - Señal deformada",
  DUPLICATE_PAGE_TITLE: ". - Dirección duplicada",

  TERMINATION_OFF_DOTS: "......................................................................................................",
  NO_TERMINATION_DOTS: "............................................................................................................",
  NO_POWER_SUPPLY_DOTS: "......................................................................................................",
  HIGH_RESISTANCE_DOTS: "............................................................................................................................",
  A_NOT_OK_DOTS: "...........................................................................................",
  B_NOT_OK_DOTS: "...........................................................................................",
  LONG_CABLE_DOTS: "....................................................................................................................................",
  NOISE_DOTS: ".....................................................................................",
  REFLECTION_DOTS: "....................................................................................................",
  DEFORMED_WAVE_DOTS: ".......................................................................................................................",
  DEFORMED_WAVE_DOTS_2: ".........................................................................................................................",

  DUPLICATE_ADDRESS_DOTS: "..................................................................................................................",
  DUPLICATE_ADDRESS_DOTS_2: "....................................................................................................................",

  SUGGESTION: "Se sugiere",
  EVIDENCE: "Evidencias",
  EVIDENCE_DESCRIPTION: "Captura de evidencia de la no conformidad informada por TS Expert:",

  TERMINATION_OFF_PAGE_DESCRIPTION: "TS Expert está indicando una posible falta de terminador en la red.",
  NO_TERMINATION_PAGE_DESCRIPTION: "TS Expert está indicando una posible ausencia de terminador en el segmento al que está conectado.",
  NO_POWER_SUPPLY_PAGE_DESCRIPTION: "TS Expert está indicando una posible falta de alimentación en el terminador.",
  HIGH_RESISTANCE_PAGE_DESCRIPTION: "TS Expert está indicando un posible exceso de terminadores o alta resistencia en el bus PROFIBUS.",
  A_NOT_OK_PAGE_DESCRIPTION: "TS Expert está indicando un posible cortocircuito entre el conductor A y la malla de blindaje o la masa aterrada de un panel o esclavo.",
  B_NOT_OK_PAGE_DESCRIPTION: "TS Expert está indicando un posible cortocircuito entre el conductor B y la malla de blindaje o la masa aterrada de un panel o esclavo.",
  LONG_CABLE_PAGE_DESCRIPTION: "TS Expert está indicando una posible condición de bus con longitud mayor a la permitida.",
  NOISE_PAGE_DESCRIPTION: "TS Expert está indicando una posible condición de ruido en la red PROFIBUS.",
  REFLECTION_PAGE_DESCRIPTION: "TS Expert está indicando la presencia de reflexión en la forma de onda.",
  DEFORMED_WAVE_PAGE_DESCRIPTION: "TS Expert está indicando la presencia de señal fuera del patrón",
  DUPLICATE_PAGE_DESCRIPTION: "TS Expert está indicando la posible presencia de dirección duplicada.",

  TERMINATION_OFF_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, ya que aún se está detectando un terminador en posición OFF:\n",
  NO_POWER_SUPPLY_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, ya que aún se está detectando un terminador sin alimentación:\n",
  HIGH_RESISTANCE_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, ya que aún se está detectando una señal atenuada:\n",
  A_NOT_OK_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, ya que aún se está detectando un cortocircuito entre el conductor A y la malla:\n",
  B_NOT_OK_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, ya que aún se está detectando un cortocircuito entre el conductor B y la malla:\n",
  LONG_CABLE_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, ya que aún se está detectando un cable con longitud excesiva:\n",
  NOISE_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, ya que aún se está detectando ruido o baja aislación:\n",
  REFLECTION_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, ya que aún se está detectando reflexión en la forma de onda:\n",

  S_TERMINATION_OFF_INITIAL_ERROR_MSG: "No fue posible verificar el evento del dispositivo, ya que aún se está detectando que el terminador está en posición OFF\n",
  S_NO_POWER_SUPPLY_INITIAL_ERROR_MSG: "No fue posible verificar el evento del dispositivo, ya que aún se está detectando que el terminador está sin alimentación\n",
  S_HIGH_RESISTANCE_INITIAL_ERROR_MSG: "No fue posible verificar el evento del dispositivo, ya que aún se está detectando que existen 2 terminadores o que la resistencia en el bus es alta\n",
  S_A_NOT_OK_INITIAL_ERROR_MSG: "No fue posible verificar el evento del dispositivo, ya que aún se está detectando un posible cortocircuito entre el conductor A y la malla de blindaje, o la masa puesta a tierra de un panel o esclavo\n",
  S_B_NOT_OK_INITIAL_ERROR_MSG: "No fue posible verificar el evento del dispositivo, ya que aún se está detectando un posible cortocircuito entre el conductor B y la malla de blindaje, o la masa puesta a tierra de un panel o esclavo\n",
  S_LONG_CABLE_INITIAL_ERROR_MSG: "No fue posible verificar el evento del dispositivo, ya que aún se está detectando una posible condición de bus con longitud mayor a la permitida\n",
  S_NOISE_INITIAL_ERROR_MSG: "No fue posible verificar el evento del dispositivo, ya que aún se está detectando una posible condición de ruido en la red PROFIBUS\n",
  S_REFLECTION_INITIAL_ERROR_MSG: "No fue posible verificar el evento del dispositivo, ya que aún se está detectando la presencia de reflexión en la forma de onda\n",

  // ---------------------------- Temperature Alert ----------------------------
  IDLE_SIZE: "Tamaño del idle",
  PACKET_SIZE: "Tamaño del paquete",

  SMALL: "Pequeño",
  MEDIUM: "Mediano",
  BIG: "Grande",

  IDLE_SIZE_QUESTION_ICON_INFO: "El tamaño del idle se refiere a la cantidad de puntos considerados al comienzo de la forma de onda de la respuesta del device. Es posible configurar tres tamaños distintos:",
  IDLE_SIZE_QUESTION_ICON_INFO_1: "Tamaño de idle estándar (Varía según el baud rate);",
  IDLE_SIZE_QUESTION_ICON_INFO_2: "Aumenta el tamaño en 1 tiempo de un bit;",
  IDLE_SIZE_QUESTION_ICON_INFO_3: "Aumenta el tamaño en 2 tiempos de un bit.",

  PACKET_SIZE_QUESTION_ICON_INFO: "El tamaño del paquete es la cantidad total de puntos que TS Monitor PROFIBUS PRO captura en un único paquete de datos. Es posible configurar tres tamaños distintos:",
  PACKET_SIZE_QUESTION_ICON_INFO_1: "Tamaño de paquete estándar (Varía según el baud rate);",
  PACKET_SIZE_QUESTION_ICON_INFO_2: "Aumenta el tamaño del paquete en 100 puntos;",
  PACKET_SIZE_QUESTION_ICON_INFO_3: "Aumenta el tamaño del paquete en 200 puntos.",

  IDLE_SIZE_WAITING: "Realizando procedimientos para cambiar el tamaño del idle, por favor espere en esta pantalla hasta que finalicen.",
  IDLE_SIZE_WAS_CHANGED_SUCCESSFULLY: "El tamaño del idle fue cambiado con éxito",
  IDLE_SIZE_CHANGE_FAILURE: "Ocurrió un error al cambiar el tamaño del idle.",

  PACKET_SIZE_WAITING: "Realizando procedimientos para cambiar el tamaño del paquete, por favor espere en esta pantalla hasta que finalicen.",
  PACKET_SIZE_WAS_CHANGED_SUCCESSFULLY: "El tamaño del paquete fue cambiado con éxito",
  PACKET_SIZE_CHANGE_FAILURE: "Ocurrió un error al cambiar el tamaño del paquete.",

  REASON_DP: "Motivo: ",

  // ---------------------------- Segment Devices ----------------------------
  CHECK_MASTER: "Verificar maestro",
  START_SEARCH_ERROR_MESSAGE: "Ocurrió un error al iniciar la búsqueda de dispositivos. Por favor intente nuevamente.",
  SEARCH_FINISH_SUCCESS: "¡Búsqueda de dispositivos finalizada con éxito!",
  GET_DEVICES_LIST_ERROR: "Ocurrió un error al cargar la lista de dispositivos.",

  IN_SEGMENT: "Actualmente en el segmento",
  POSSIBLY_IN_SEGMENT: "Identificado como perteneciente",
  POSSIBLY_OUT_OF_SEGMENT: "Se detectó que este dispositivo puede estar en otro segmento",

  SEND_SEGMENT_DEVICES_INFO_SUCCESS: "¡La información sobre los dispositivos del segmento fue enviada con éxito!",
  SEND_SEGMENT_DEVICES_INFO_ERROR: "Ocurrió un error al enviar la información sobre los dispositivos del segmento.",

  SEARCH: "Buscar",
  SEARCH_POPUP_1: "Para utilizar la parte de Capa Física DP por primera vez se recomienda seleccionar cuáles dispositivos pertenecen al segmento.",
  SEARCH_POPUP_2: "Presione el botón de abajo para realizar una búsqueda y encontrar todos los dispositivos alcanzables en la red.",
  SEARCH_POPUP_3_1: "Después de la búsqueda, los dispositivos encontrados se agregarán a la lista de ",
  SEARCH_POPUP_3_2: "dispositivos disponibles",
  SEARCH_POPUP_3_3: " al lado. Los dispositivos disponibles ",
  SEARCH_POPUP_3_4: "son todos aquellos encontrados, pertenezcan o no al segmento de red actual.",
  SEARCH_POPUP_4_1: "La otra lista, de ",
  SEARCH_POPUP_4_2: "dispositivos seleccionados",
  SEARCH_POPUP_4_3: ", es la lista que ",
  SEARCH_POPUP_4_4: "contiene los dispositivos seleccionados por el usuario de los que está seguro que están en el segmento de red actual.",
  SEARCH_POPUP_4_5: " Inicialmente esta lista estará vacía.",
  SEARCH_POPUP_5: "Realizada la búsqueda, corresponderá al usuario seleccionar cuáles de estos dispositivos realmente pertenecen al segmento de red, moviéndolos de la lista de dispositivos disponibles a la lista de dispositivos seleccionados.",
  SEARCH_POPUP_6_1: "OBS: ",
  SEARCH_POPUP_6_2: "Los maestros de la red siempre son monitoreados por TS Monitor PROFIBUS PRO, por lo tanto no aparecen en esta página.",

  SAVE_POPUP_1_1: "Al hacer clic en el botón de abajo, los dispositivos que estén en la lista ",
  SAVE_POPUP_1_2: "Dispositivos seleccionados",
  SAVE_POPUP_1_3: " serán guardados.",
  SAVE_POPUP_2_1: "Al realizar este procedimiento, solo los dispositivos de la lista ",
  SAVE_POPUP_2_2: "Dispositivos seleccionados",
  SAVE_POPUP_2_3: " serán monitoreados por la Capa Física DP, y ",
  SAVE_POPUP_2_4: "solo ellos se mostrarán en las pantallas de la Capa Física DP, como: Live List, Matriz, Osciloscopio, etc.",

  EXPLANATION: "Explicación",

  SAVE_POPUP_3: "Esta funcionalidad es importante para identificar los esclavos pertenecientes al segmento de red PROFIBUS. Esto reduce el tiempo de respuesta, ya que el sistema estará verificando los esclavos pertinentes.",
  SAVE_POPUP_4: "También es de gran utilidad para que quienes tengan menos conocimiento de la red no busquen el problema en un segmento equivocado.",

  AVAILABLE_DEVICES: "Dispositivos disponibles",
  AVAILABLE_DEVICES_POPUP_1_1: "Esta lista contiene todos los dispositivos ",
  AVAILABLE_DEVICES_POPUP_1_2: "encontrados en la red.",
  AVAILABLE_DEVICES_POPUP_2: "TS Monitor PROFIBUS PRO sugiere los dispositivos que cree que pertenecen al segmento de red actual, indicándolos como: ",
  AVAILABLE_DEVICES_POPUP_2_1: " Identificado como perteneciente.",

  AVAILABLE_DEVICES_POPUP_3_1: "Hacer clic en el botón ",
  AVAILABLE_DEVICES_POPUP_3_2: " mueve un dispositivo de la lista de ",
  AVAILABLE_DEVICES_POPUP_3_3: "dispositivos disponibles",
  AVAILABLE_DEVICES_POPUP_3_4: " a la lista de ",
  AVAILABLE_DEVICES_POPUP_3_5: "dispositivos seleccionados",
  AVAILABLE_DEVICES_POPUP_3_6: ", indicando que pertenece al segmento actual de la red. Después de mover los dispositivos es necesario hacer clic en el botón ",
  AVAILABLE_DEVICES_POPUP_3_7: "Guardar",
  AVAILABLE_DEVICES_POPUP_3_8: " para registrar estos cambios.",

  AVAILABLE_DEVICES_POPUP_4_1: "OBS: ",
  AVAILABLE_DEVICES_POPUP_4_2: "Corresponde al usuario tomar la decisión final y decidir cuáles dispositivos realmente pertenecen al segmento.",

  LOADING_DEVICES: "Cargando dispositivos",

  MOVE_ALL: "Mover todos",

  SELECTED_DEVICES: "Dispositivos seleccionados",

  SELECTED_DEVICES_POPUP_1_1: "Esta lista contiene todos los dispositivos que el usuario marcó como ",
  SELECTED_DEVICES_POPUP_1_2: "pertenecientes al segmento de red actual.",

  SELECTED_DEVICES_POPUP_2_1: "Es importante destacar que, después de hacer clic en el botón ",
  SELECTED_DEVICES_POPUP_2_2: "Guardar",
  SELECTED_DEVICES_POPUP_2_3: ", la parte de Capa Física DP ",
  SELECTED_DEVICES_POPUP_2_4: "solo monitoreará los dispositivos que estén en la lista de dispositivos seleccionados.",

  SELECTED_DEVICES_POPUP_3_1: "Esto significa que:",
  SELECTED_DEVICES_POPUP_3_2: " Los dispositivos que no estén en esta lista no se mostrarán en las pantallas de Capa Física DP, tales como: Live List, Matriz, Osciloscopio, Gráfico de barras, etc.",

  CONFIRM_SEARCH_START: "¿Está seguro de que desea iniciar la búsqueda?",

  CONFIRM_SEARCH_START_POPUP_1_1: "El procedimiento de búsqueda de dispositivos tomará ",
  CONFIRM_SEARCH_START_POPUP_1_2: "5 (cinco) minutos",
  CONFIRM_SEARCH_START_POPUP_1_3: " para completarse.",

  CONFIRM_SEARCH_START_POPUP_2_1: " Durante la búsqueda ",
  CONFIRM_SEARCH_START_POPUP_2_2: "diversos procedimientos internos de TS Monitor PROFIBUS PRO serán reiniciados",
  CONFIRM_SEARCH_START_POPUP_2_3: ", y por esta razón, solo volverá a funcionar normalmente una vez que la búsqueda haya finalizado.",

  SEARCHING_DEVICES: "Buscando dispositivos.",
  PLEASE_STAY_IN_PAGE: "Por favor permanezca en la página para seguir el progreso de la búsqueda.",

  SENDING_DEVICES_INFO: "Enviando información sobre los dispositivos, espere.",

  // ---------------------------- LANGUAGE ----------------------------
  PORTUGUESE: "Portugués",
  ENGLISH: "Inglés",
  SPANISH: "Español",
  GERMAN: "Alemán",
  UPDATING_LANGUAGE_WAITING: "Cambiando el idioma, espere un momento",
  UNABLE_TO_ALTER_LANGUAGE: "No fue posible cambiar el idioma del programa.\n",

  // ---------------------------- SHARED STRINGS ----------------------------
  MONITORING: "Protocolo",
  PHYS_MEDIUM: "Capa física DP",
  GENERAL: "Generales",
  TS_EXPERT_PROT: "TS Expert - Protocolo",
  TS_EXPERT_DP: "TS Expert - Capa física DP",
  TS_EXPERT_OF: "TS Expert - Fibra óptica",
  HEADER_TEXT_PRO: "Informe de datos - TS Monitor PROFIBUS PRO",
  PHYS_MEDIUM_DOTS: ".......................................................................................................",
  MONITORING_DOTS: ".................................................................................................................",
  DISCLAIMER_DOTS_PRO: ".......................................................................................................................................",

  NETWORK_DP: "Red:",
  SEGMENT_DP: "Segmento:",

  IP_ASSOCIATED_MONITOR: "Dirección IP del monitor asociado: ",
});

export default Constants;